import Vue from "vue";
import Test_1 from "@/components/test.vue";
Vue.component("cbTest", Test_1);

export default {
  name: "S&P 500",
  desc: "EOD Quote",
  table: {
    DATE: "2023-12-11",
    Open: 4593.39,
    "Day High": 4623.71,
    "Day Low": 4593.39,
    "Prev Close": 4604.37,
    "%CHG": "0.39",
  },
  dataList: [
    {
      DATE: "2022-12-13",
      Close: 4019.65,
      Open: 4069.38,
      High: Math.random() * 4000,
      Low: 3993.03,
      Volume: "-",
    },
    {
      DATE: "2022-12-14",
      Close: 3995.32,
      Open: 4015.54,
      High: 4053.76,
      Low: 3965.65,
      Volume: "-",
    },
    {
      DATE: "2022-12-15",
      Close: 3895.75,
      Open: 3958.37,
      High: 3958.37,
      Low: 3879.45,
      Volume: "-",
    },
    {
      DATE: "2022-12-16",
      Close: 3852.36,
      Open: 3890.91,
      High: 3890.91,
      Low: 3827.91,
      Volume: "-",
    },
    {
      DATE: "2022-12-19",
      Close: 3817.66,
      Open: 3853.79,
      High: 3854.86,
      Low: 3800.04,
      Volume: "-",
    },
    {
      DATE: "2022-12-20",
      Close: 3821.62,
      Open: 3810.47,
      High: 3838.24,
      Low: 3795.62,
      Volume: "-",
    },
    {
      DATE: "2022-12-21",
      Close: 3878.44,
      Open: 3839.49,
      High: 3889.82,
      Low: 3839.49,
      Volume: "-",
    },
    {
      DATE: "2022-12-22",
      Close: 3822.39,
      Open: 3853.26,
      High: 3853.26,
      Low: 3764.49,
      Volume: "-",
    },
    {
      DATE: "2022-12-23",
      Close: 3844.82,
      Open: 3815.11,
      High: 3845.8,
      Low: 3797.01,
      Volume: "-",
    },
    {
      DATE: "2022-12-27",
      Close: 3829.25,
      Open: 3843.34,
      High: 3846.65,
      Low: 3813.22,
      Volume: "-",
    },
    {
      DATE: "2022-12-28",
      Close: 3783.22,
      Open: 3829.56,
      High: 3848.32,
      Low: 3780.78,
      Volume: "-",
    },
    {
      DATE: "2022-12-29",
      Close: 3849.28,
      Open: 3805.45,
      High: 3858.19,
      Low: 3805.45,
      Volume: "-",
    },
    {
      DATE: "2022-12-30",
      Close: 3839.5,
      Open: 3829.06,
      High: 3839.85,
      Low: 3800.34,
      Volume: "-",
    },
    {
      DATE: "2023-01-03",
      Close: 3824.14,
      Open: 3853.29,
      High: 3878.46,
      Low: 3794.33,
      Volume: "-",
    },
    {
      DATE: "2023-01-04",
      Close: 3852.97,
      Open: 3840.36,
      High: 3873.16,
      Low: 3815.77,
      Volume: "-",
    },
    {
      DATE: "2023-01-05",
      Close: 3808.1,
      Open: 3839.74,
      High: 3839.74,
      Low: 3802.42,
      Volume: "-",
    },
    {
      DATE: "2023-01-06",
      Close: 3895.08,
      Open: 3823.37,
      High: 3906.19,
      Low: 3809.56,
      Volume: "-",
    },
    {
      DATE: "2023-01-09",
      Close: 3892.09,
      Open: 3910.82,
      High: 3950.57,
      Low: 3890.42,
      Volume: "-",
    },
    {
      DATE: "2023-01-10",
      Close: 3919.25,
      Open: 3888.57,
      High: 3919.83,
      Low: 3877.29,
      Volume: "-",
    },
    {
      DATE: "2023-01-11",
      Close: 3969.61,
      Open: 3932.35,
      High: 3970.07,
      Low: 3928.54,
      Volume: "-",
    },
    {
      DATE: "2023-01-12",
      Close: 3983.17,
      Open: 3977.57,
      High: 3997.76,
      Low: 3937.56,
      Volume: "-",
    },
    {
      DATE: "2023-01-13",
      Close: 3999.09,
      Open: 3960.6,
      High: 4003.95,
      Low: 3947.67,
      Volume: "-",
    },
    {
      DATE: "2023-01-17",
      Close: 3990.97,
      Open: 3999.28,
      High: 4015.39,
      Low: 3984.57,
      Volume: "-",
    },
    {
      DATE: "2023-01-18",
      Close: 3928.86,
      Open: 4002.25,
      High: 4014.16,
      Low: 3926.59,
      Volume: "-",
    },
    {
      DATE: "2023-01-19",
      Close: 3898.85,
      Open: 3911.84,
      High: 3922.94,
      Low: 3885.54,
      Volume: "-",
    },
    {
      DATE: "2023-01-20",
      Close: 3972.61,
      Open: 3909.04,
      High: 3972.96,
      Low: 3897.86,
      Volume: "-",
    },
    {
      DATE: "2023-01-23",
      Close: 4019.81,
      Open: 3978.14,
      High: 4039.31,
      Low: 3971.64,
      Volume: "-",
    },
    {
      DATE: "2023-01-24",
      Close: 4016.95,
      Open: 4001.74,
      High: 4023.92,
      Low: 3989.79,
      Volume: "-",
    },
    {
      DATE: "2023-01-25",
      Close: 4016.22,
      Open: 3982.71,
      High: 4019.55,
      Low: 3949.06,
      Volume: "-",
    },
    {
      DATE: "2023-01-26",
      Close: 4060.43,
      Open: 4036.08,
      High: 4061.57,
      Low: 4013.29,
      Volume: "-",
    },
    {
      DATE: "2023-01-27",
      Close: 4070.56,
      Open: 4053.72,
      High: 4094.21,
      Low: 4048.7,
      Volume: "-",
    },
    {
      DATE: "2023-01-30",
      Close: 4017.77,
      Open: 4049.27,
      High: 4063.85,
      Low: 4015.55,
      Volume: "-",
    },
    {
      DATE: "2023-01-31",
      Close: 4076.6,
      Open: 4020.85,
      High: 4077.16,
      Low: 4020.44,
      Volume: "-",
    },
    {
      DATE: "2023-02-01",
      Close: 4119.21,
      Open: 4070.07,
      High: 4148.95,
      Low: 4037.2,
      Volume: "-",
    },
    {
      DATE: "2023-02-02",
      Close: 4179.76,
      Open: 4158.68,
      High: 4195.44,
      Low: 4141.88,
      Volume: "-",
    },
    {
      DATE: "2023-02-03",
      Close: 4136.48,
      Open: 4136.69,
      High: 4182.36,
      Low: 4123.36,
      Volume: "-",
    },
    {
      DATE: "2023-02-06",
      Close: 4111.08,
      Open: 4119.57,
      High: 4124.63,
      Low: 4093.38,
      Volume: "-",
    },
    {
      DATE: "2023-02-07",
      Close: 4164,
      Open: 4105.35,
      High: 4176.54,
      Low: 4088.39,
      Volume: "-",
    },
    {
      DATE: "2023-02-08",
      Close: 4117.86,
      Open: 4153.47,
      High: 4156.85,
      Low: 4111.67,
      Volume: "-",
    },
    {
      DATE: "2023-02-09",
      Close: 4081.5,
      Open: 4144.25,
      High: 4156.23,
      Low: 4069.67,
      Volume: "-",
    },
    {
      DATE: "2023-02-10",
      Close: 4090.46,
      Open: 4068.92,
      High: 4094.36,
      Low: 4060.79,
      Volume: "-",
    },
    {
      DATE: "2023-02-13",
      Close: 4137.29,
      Open: 4096.62,
      High: 4138.9,
      Low: 4092.67,
      Volume: "-",
    },
    {
      DATE: "2023-02-14",
      Close: 4136.13,
      Open: 4126.7,
      High: 4159.77,
      Low: 4095.01,
      Volume: "-",
    },
    {
      DATE: "2023-02-15",
      Close: 4147.6,
      Open: 4119.5,
      High: 4148.11,
      Low: 4103.98,
      Volume: "-",
    },
    {
      DATE: "2023-02-16",
      Close: 4090.41,
      Open: 4114.75,
      High: 4136.54,
      Low: 4089.49,
      Volume: "-",
    },
    {
      DATE: "2023-02-17",
      Close: 4079.09,
      Open: 4077.39,
      High: 4081.51,
      Low: 4047.95,
      Volume: "-",
    },
    {
      DATE: "2023-02-21",
      Close: 3997.34,
      Open: 4052.35,
      High: 4052.35,
      Low: 3995.19,
      Volume: "-",
    },
    {
      DATE: "2023-02-22",
      Close: 3991.05,
      Open: 4001.83,
      High: 4017.37,
      Low: 3976.9,
      Volume: "-",
    },
    {
      DATE: "2023-02-23",
      Close: 4012.32,
      Open: 4018.6,
      High: 4028.3,
      Low: 3969.19,
      Volume: "-",
    },
    {
      DATE: "2023-02-24",
      Close: 3970.04,
      Open: 3973.24,
      High: 3978.25,
      Low: 3943.08,
      Volume: "-",
    },
    {
      DATE: "2023-02-27",
      Close: 3982.24,
      Open: 3992.36,
      High: 4018.05,
      Low: 3973.55,
      Volume: "-",
    },
    {
      DATE: "2023-02-28",
      Close: 3970.15,
      Open: 3977.19,
      High: 3997.5,
      Low: 3968.98,
      Volume: "-",
    },
    {
      DATE: "2023-03-01",
      Close: 3951.39,
      Open: 3963.34,
      High: 3971.73,
      Low: 3939.05,
      Volume: "-",
    },
    {
      DATE: "2023-03-02",
      Close: 3981.35,
      Open: 3938.68,
      High: 3990.84,
      Low: 3928.16,
      Volume: "-",
    },
    {
      DATE: "2023-03-03",
      Close: 4045.64,
      Open: 3998.02,
      High: 4048.29,
      Low: 3995.17,
      Volume: "-",
    },
    {
      DATE: "2023-03-06",
      Close: 4048.42,
      Open: 4055.15,
      High: 4078.49,
      Low: 4044.61,
      Volume: "-",
    },
    {
      DATE: "2023-03-07",
      Close: 3986.37,
      Open: 4048.26,
      High: 4050,
      Low: 3980.31,
      Volume: "-",
    },
    {
      DATE: "2023-03-08",
      Close: 3992.01,
      Open: 3987.55,
      High: 4000.41,
      Low: 3969.76,
      Volume: "-",
    },
    {
      DATE: "2023-03-09",
      Close: 3918.32,
      Open: 3998.66,
      High: 4017.81,
      Low: 3908.7,
      Volume: "-",
    },
    {
      DATE: "2023-03-10",
      Close: 3861.59,
      Open: 3912.77,
      High: 3934.05,
      Low: 3846.32,
      Volume: "-",
    },
    {
      DATE: "2023-03-13",
      Close: 3855.76,
      Open: 3835.12,
      High: 3905.05,
      Low: 3808.86,
      Volume: "-",
    },
    {
      DATE: "2023-03-14",
      Close: 3919.29,
      Open: 3894.01,
      High: 3937.29,
      Low: 3873.63,
      Volume: "-",
    },
    {
      DATE: "2023-03-15",
      Close: 3891.93,
      Open: 3876.74,
      High: 3894.26,
      Low: 3838.24,
      Volume: "-",
    },
    {
      DATE: "2023-03-16",
      Close: 3960.28,
      Open: 3878.93,
      High: 3964.46,
      Low: 3864.11,
      Volume: "-",
    },
    {
      DATE: "2023-03-17",
      Close: 3916.64,
      Open: 3958.69,
      High: 3958.91,
      Low: 3901.27,
      Volume: "-",
    },
    {
      DATE: "2023-03-20",
      Close: 3951.57,
      Open: 3917.47,
      High: 3956.62,
      Low: 3916.89,
      Volume: "-",
    },
    {
      DATE: "2023-03-21",
      Close: 4002.87,
      Open: 3975.89,
      High: 4009.08,
      Low: 3971.19,
      Volume: "-",
    },
    {
      DATE: "2023-03-22",
      Close: 3936.97,
      Open: 4002.04,
      High: 4039.49,
      Low: 3936.17,
      Volume: "-",
    },
    {
      DATE: "2023-03-23",
      Close: 3948.72,
      Open: 3959.21,
      High: 4007.66,
      Low: 3919.05,
      Volume: "-",
    },
    {
      DATE: "2023-03-24",
      Close: 3970.99,
      Open: 3939.21,
      High: 3972.74,
      Low: 3909.16,
      Volume: "-",
    },
    {
      DATE: "2023-03-27",
      Close: 3977.53,
      Open: 3982.93,
      High: 4003.83,
      Low: 3970.49,
      Volume: "-",
    },
    {
      DATE: "2023-03-28",
      Close: 3971.27,
      Open: 3974.13,
      High: 3979.2,
      Low: 3951.53,
      Volume: "-",
    },
    {
      DATE: "2023-03-29",
      Close: 4027.81,
      Open: 3999.53,
      High: 4030.59,
      Low: 3999.53,
      Volume: "-",
    },
    {
      DATE: "2023-03-30",
      Close: 4050.83,
      Open: 4046.74,
      High: 4057.85,
      Low: 4032.1,
      Volume: "-",
    },
    {
      DATE: "2023-03-31",
      Close: 4109.31,
      Open: 4056.18,
      High: 4110.75,
      Low: 4056.18,
      Volume: "-",
    },
    {
      DATE: "2023-04-03",
      Close: 4124.51,
      Open: 4102.2,
      High: 4127.66,
      Low: 4098.79,
      Volume: "-",
    },
    {
      DATE: "2023-04-04",
      Close: 4100.6,
      Open: 4128.03,
      High: 4133.13,
      Low: 4086.87,
      Volume: "-",
    },
    {
      DATE: "2023-04-05",
      Close: 4090.38,
      Open: 4094.5,
      High: 4099.69,
      Low: 4072.56,
      Volume: "-",
    },
    {
      DATE: "2023-04-06",
      Close: 4105.02,
      Open: 4081.15,
      High: 4107.32,
      Low: 4069.84,
      Volume: "-",
    },
    {
      DATE: "2023-04-10",
      Close: 4109.11,
      Open: 4085.2,
      High: 4109.5,
      Low: 4072.55,
      Volume: "-",
    },
    {
      DATE: "2023-04-11",
      Close: 4108.94,
      Open: 4110.29,
      High: 4124.26,
      Low: 4102.61,
      Volume: "-",
    },
    {
      DATE: "2023-04-12",
      Close: 4091.95,
      Open: 4121.72,
      High: 4134.37,
      Low: 4086.94,
      Volume: "-",
    },
    {
      DATE: "2023-04-13",
      Close: 4146.22,
      Open: 4100.04,
      High: 4150.26,
      Low: 4099.4,
      Volume: "-",
    },
    {
      DATE: "2023-04-14",
      Close: 4137.64,
      Open: 4140.11,
      High: 4163.19,
      Low: 4113.2,
      Volume: "-",
    },
    {
      DATE: "2023-04-17",
      Close: 4151.32,
      Open: 4137.17,
      High: 4151.72,
      Low: 4123.18,
      Volume: "-",
    },
    {
      DATE: "2023-04-18",
      Close: 4154.87,
      Open: 4164.26,
      High: 4169.48,
      Low: 4140.36,
      Volume: "-",
    },
    {
      DATE: "2023-04-19",
      Close: 4154.52,
      Open: 4139.33,
      High: 4162.57,
      Low: 4134.49,
      Volume: "-",
    },
    {
      DATE: "2023-04-20",
      Close: 4129.79,
      Open: 4130.48,
      High: 4148.57,
      Low: 4114.57,
      Volume: "-",
    },
    {
      DATE: "2023-04-21",
      Close: 4133.52,
      Open: 4132.14,
      High: 4138.02,
      Low: 4113.86,
      Volume: "-",
    },
    {
      DATE: "2023-04-24",
      Close: 4137.04,
      Open: 4132.07,
      High: 4142.41,
      Low: 4117.77,
      Volume: "-",
    },
    {
      DATE: "2023-04-25",
      Close: 4071.63,
      Open: 4126.43,
      High: 4126.43,
      Low: 4071.38,
      Volume: "-",
    },
    {
      DATE: "2023-04-26",
      Close: 4055.99,
      Open: 4087.78,
      High: 4089.67,
      Low: 4049.35,
      Volume: "-",
    },
    {
      DATE: "2023-04-27",
      Close: 4135.35,
      Open: 4075.29,
      High: 4138.24,
      Low: 4075.29,
      Volume: "-",
    },
    {
      DATE: "2023-04-28",
      Close: 4169.48,
      Open: 4129.63,
      High: 4170.06,
      Low: 4127.18,
      Volume: "-",
    },
    {
      DATE: "2023-05-01",
      Close: 4167.87,
      Open: 4166.79,
      High: 4186.92,
      Low: 4164.12,
      Volume: "-",
    },
    {
      DATE: "2023-05-02",
      Close: 4119.58,
      Open: 4164.1,
      High: 4164.1,
      Low: 4089.72,
      Volume: "-",
    },
    {
      DATE: "2023-05-03",
      Close: 4090.75,
      Open: 4122.25,
      High: 4148.3,
      Low: 4088.86,
      Volume: "-",
    },
    {
      DATE: "2023-05-04",
      Close: 4061.22,
      Open: 4082.55,
      High: 4082.61,
      Low: 4048.28,
      Volume: "-",
    },
    {
      DATE: "2023-05-05",
      Close: 4136.25,
      Open: 4084.73,
      High: 4147.02,
      Low: 4084.73,
      Volume: "-",
    },
    {
      DATE: "2023-05-08",
      Close: 4138.12,
      Open: 4136.98,
      High: 4142.3,
      Low: 4123.81,
      Volume: "-",
    },
    {
      DATE: "2023-05-09",
      Close: 4119.17,
      Open: 4124.25,
      High: 4130.35,
      Low: 4116.65,
      Volume: "-",
    },
    {
      DATE: "2023-05-10",
      Close: 4137.64,
      Open: 4143.74,
      High: 4154.28,
      Low: 4098.92,
      Volume: "-",
    },
    {
      DATE: "2023-05-11",
      Close: 4130.62,
      Open: 4132.24,
      High: 4132.8,
      Low: 4109.29,
      Volume: "-",
    },
    {
      DATE: "2023-05-12",
      Close: 4124.08,
      Open: 4138.54,
      High: 4143.74,
      Low: 4099.12,
      Volume: "-",
    },
    {
      DATE: "2023-05-15",
      Close: 4136.28,
      Open: 4126.65,
      High: 4141.25,
      Low: 4110.27,
      Volume: "-",
    },
    {
      DATE: "2023-05-16",
      Close: 4109.9,
      Open: 4127.95,
      High: 4135.54,
      Low: 4109.86,
      Volume: "-",
    },
    {
      DATE: "2023-05-17",
      Close: 4158.77,
      Open: 4122.85,
      High: 4164.67,
      Low: 4113.62,
      Volume: "-",
    },
    {
      DATE: "2023-05-18",
      Close: 4198.05,
      Open: 4157.68,
      High: 4202.2,
      Low: 4153.5,
      Volume: "-",
    },
    {
      DATE: "2023-05-19",
      Close: 4191.98,
      Open: 4204.15,
      High: 4212.91,
      Low: 4180.2,
      Volume: "-",
    },
    {
      DATE: "2023-05-22",
      Close: 4192.63,
      Open: 4190.78,
      High: 4209.22,
      Low: 4179.68,
      Volume: "-",
    },
    {
      DATE: "2023-05-23",
      Close: 4145.58,
      Open: 4176.8,
      High: 4185.68,
      Low: 4142.54,
      Volume: "-",
    },
    {
      DATE: "2023-05-24",
      Close: 4115.24,
      Open: 4132.96,
      High: 4132.96,
      Low: 4103.98,
      Volume: "-",
    },
    {
      DATE: "2023-05-25",
      Close: 4151.28,
      Open: 4155.71,
      High: 4165.74,
      Low: 4129.73,
      Volume: "-",
    },
    {
      DATE: "2023-05-26",
      Close: 4205.45,
      Open: 4156.16,
      High: 4212.87,
      Low: 4156.16,
      Volume: "-",
    },
    {
      DATE: "2023-05-30",
      Close: 4205.52,
      Open: 4226.71,
      High: 4231.1,
      Low: 4192.18,
      Volume: "-",
    },
    {
      DATE: "2023-05-31",
      Close: 4179.83,
      Open: 4190.74,
      High: 4195.44,
      Low: 4166.15,
      Volume: "-",
    },
    {
      DATE: "2023-06-01",
      Close: 4221.02,
      Open: 4183.03,
      High: 4232.43,
      Low: 4171.64,
      Volume: "-",
    },
    {
      DATE: "2023-06-02",
      Close: 4282.37,
      Open: 4241.01,
      High: 4290.67,
      Low: 4241.01,
      Volume: "-",
    },
    {
      DATE: "2023-06-05",
      Close: 4273.79,
      Open: 4282.99,
      High: 4299.28,
      Low: 4266.82,
      Volume: "-",
    },
    {
      DATE: "2023-06-06",
      Close: 4283.85,
      Open: 4271.34,
      High: 4288.33,
      Low: 4263.09,
      Volume: "-",
    },
    {
      DATE: "2023-06-07",
      Close: 4267.52,
      Open: 4285.47,
      High: 4299.19,
      Low: 4263.96,
      Volume: "-",
    },
    {
      DATE: "2023-06-08",
      Close: 4293.93,
      Open: 4268.69,
      High: 4298.01,
      Low: 4261.07,
      Volume: "-",
    },
    {
      DATE: "2023-06-09",
      Close: 4298.86,
      Open: 4304.88,
      High: 4322.62,
      Low: 4291.7,
      Volume: "-",
    },
    {
      DATE: "2023-06-12",
      Close: 4338.93,
      Open: 4308.32,
      High: 4340.13,
      Low: 4304.37,
      Volume: "-",
    },
    {
      DATE: "2023-06-13",
      Close: 4369.01,
      Open: 4352.61,
      High: 4375.37,
      Low: 4349.31,
      Volume: "-",
    },
    {
      DATE: "2023-06-14",
      Close: 4372.59,
      Open: 4366.29,
      High: 4391.82,
      Low: 4337.85,
      Volume: "-",
    },
    {
      DATE: "2023-06-15",
      Close: 4425.84,
      Open: 4365.33,
      High: 4439.2,
      Low: 4362.6,
      Volume: "-",
    },
    {
      DATE: "2023-06-16",
      Close: 4409.59,
      Open: 4440.95,
      High: 4448.47,
      Low: 4407.44,
      Volume: "-",
    },
    {
      DATE: "2023-06-20",
      Close: 4388.71,
      Open: 4396.11,
      High: 4400.15,
      Low: 4367.19,
      Volume: "-",
    },
    {
      DATE: "2023-06-21",
      Close: 4365.69,
      Open: 4380.01,
      High: 4386.22,
      Low: 4360.14,
      Volume: "-",
    },
    {
      DATE: "2023-06-22",
      Close: 4381.89,
      Open: 4355.4,
      High: 4382.25,
      Low: 4351.82,
      Volume: "-",
    },
    {
      DATE: "2023-06-23",
      Close: 4348.33,
      Open: 4354.17,
      High: 4366.55,
      Low: 4341.34,
      Volume: "-",
    },
    {
      DATE: "2023-06-26",
      Close: 4328.82,
      Open: 4344.84,
      High: 4362.06,
      Low: 4328.08,
      Volume: "-",
    },
    {
      DATE: "2023-06-27",
      Close: 4378.41,
      Open: 4337.36,
      High: 4384.42,
      Low: 4335,
      Volume: "-",
    },
    {
      DATE: "2023-06-28",
      Close: 4376.86,
      Open: 4367.48,
      High: 4390.35,
      Low: 4360.22,
      Volume: "-",
    },
    {
      DATE: "2023-06-29",
      Close: 4396.44,
      Open: 4374.94,
      High: 4398.39,
      Low: 4371.97,
      Volume: "-",
    },
    {
      DATE: "2023-06-30",
      Close: 4450.38,
      Open: 4422.44,
      High: 4458.48,
      Low: 4422.44,
      Volume: "-",
    },
    {
      DATE: "2023-07-03",
      Close: 4455.59,
      Open: 4450.48,
      High: 4456.46,
      Low: 4442.29,
      Volume: "-",
    },
    {
      DATE: "2023-07-05",
      Close: 4446.82,
      Open: 4442.04,
      High: 4454.06,
      Low: 4436.61,
      Volume: "-",
    },
    {
      DATE: "2023-07-06",
      Close: 4411.59,
      Open: 4422.62,
      High: 4422.62,
      Low: 4385.05,
      Volume: "-",
    },
    {
      DATE: "2023-07-07",
      Close: 4398.95,
      Open: 4404.54,
      High: 4440.39,
      Low: 4397.4,
      Volume: "-",
    },
    {
      DATE: "2023-07-10",
      Close: 4409.53,
      Open: 4394.23,
      High: 4412.6,
      Low: 4389.92,
      Volume: "-",
    },
    {
      DATE: "2023-07-11",
      Close: 4439.26,
      Open: 4415.55,
      High: 4443.64,
      Low: 4408.46,
      Volume: "-",
    },
    {
      DATE: "2023-07-12",
      Close: 4472.16,
      Open: 4467.69,
      High: 4488.34,
      Low: 4463.23,
      Volume: "-",
    },
    {
      DATE: "2023-07-13",
      Close: 4510.04,
      Open: 4491.5,
      High: 4517.38,
      Low: 4489.36,
      Volume: "-",
    },
    {
      DATE: "2023-07-14",
      Close: 4505.42,
      Open: 4514.61,
      High: 4527.76,
      Low: 4499.56,
      Volume: "-",
    },
    {
      DATE: "2023-07-17",
      Close: 4522.79,
      Open: 4508.86,
      High: 4532.85,
      Low: 4504.9,
      Volume: "-",
    },
    {
      DATE: "2023-07-18",
      Close: 4554.98,
      Open: 4521.78,
      High: 4562.3,
      Low: 4514.59,
      Volume: "-",
    },
    {
      DATE: "2023-07-19",
      Close: 4565.72,
      Open: 4563.87,
      High: 4578.43,
      Low: 4557.48,
      Volume: "-",
    },
    {
      DATE: "2023-07-20",
      Close: 4534.87,
      Open: 4554.38,
      High: 4564.74,
      Low: 4527.56,
      Volume: "-",
    },
    {
      DATE: "2023-07-21",
      Close: 4536.34,
      Open: 4550.16,
      High: 4555,
      Low: 4535.79,
      Volume: "-",
    },
    {
      DATE: "2023-07-24",
      Close: 4554.64,
      Open: 4543.39,
      High: 4563.41,
      Low: 4541.29,
      Volume: "-",
    },
    {
      DATE: "2023-07-25",
      Close: 4567.46,
      Open: 4555.19,
      High: 4580.62,
      Low: 4552.42,
      Volume: "-",
    },
    {
      DATE: "2023-07-26",
      Close: 4566.75,
      Open: 4558.96,
      High: 4582.47,
      Low: 4547.58,
      Volume: "-",
    },
    {
      DATE: "2023-07-27",
      Close: 4537.41,
      Open: 4598.26,
      High: 4607.07,
      Low: 4528.56,
      Volume: "-",
    },
    {
      DATE: "2023-07-28",
      Close: 4582.23,
      Open: 4565.75,
      High: 4590.16,
      Low: 4564.01,
      Volume: "-",
    },
    {
      DATE: "2023-07-31",
      Close: 4588.96,
      Open: 4584.82,
      High: 4594.22,
      Low: 4573.14,
      Volume: "-",
    },
    {
      DATE: "2023-08-01",
      Close: 4576.73,
      Open: 4578.83,
      High: 4584.62,
      Low: 4567.53,
      Volume: "-",
    },
    {
      DATE: "2023-08-02",
      Close: 4513.39,
      Open: 4550.93,
      High: 4550.93,
      Low: 4505.75,
      Volume: "-",
    },
    {
      DATE: "2023-08-03",
      Close: 4501.89,
      Open: 4494.27,
      High: 4519.49,
      Low: 4485.54,
      Volume: "-",
    },
    {
      DATE: "2023-08-04",
      Close: 4478.03,
      Open: 4513.96,
      High: 4540.34,
      Low: 4474.55,
      Volume: "-",
    },
    {
      DATE: "2023-08-07",
      Close: 4518.44,
      Open: 4491.58,
      High: 4519.84,
      Low: 4491.15,
      Volume: "-",
    },
    {
      DATE: "2023-08-08",
      Close: 4499.38,
      Open: 4498.03,
      High: 4503.31,
      Low: 4464.39,
      Volume: "-",
    },
    {
      DATE: "2023-08-09",
      Close: 4467.71,
      Open: 4501.57,
      High: 4502.44,
      Low: 4461.33,
      Volume: "-",
    },
    {
      DATE: "2023-08-10",
      Close: 4468.83,
      Open: 4487.16,
      High: 4527.37,
      Low: 4457.92,
      Volume: "-",
    },
    {
      DATE: "2023-08-11",
      Close: 4464.05,
      Open: 4450.69,
      High: 4476.23,
      Low: 4443.98,
      Volume: "-",
    },
    {
      DATE: "2023-08-14",
      Close: 4489.72,
      Open: 4458.13,
      High: 4490.33,
      Low: 4453.44,
      Volume: "-",
    },
    {
      DATE: "2023-08-15",
      Close: 4437.86,
      Open: 4478.87,
      High: 4478.87,
      Low: 4432.19,
      Volume: "-",
    },
    {
      DATE: "2023-08-16",
      Close: 4404.33,
      Open: 4433.79,
      High: 4449.95,
      Low: 4403.55,
      Volume: "-",
    },
    {
      DATE: "2023-08-17",
      Close: 4370.36,
      Open: 4416.32,
      High: 4421.17,
      Low: 4364.83,
      Volume: "-",
    },
    {
      DATE: "2023-08-18",
      Close: 4369.71,
      Open: 4344.88,
      High: 4381.82,
      Low: 4335.31,
      Volume: "-",
    },
    {
      DATE: "2023-08-21",
      Close: 4399.77,
      Open: 4380.28,
      High: 4407.55,
      Low: 4360.3,
      Volume: "-",
    },
    {
      DATE: "2023-08-22",
      Close: 4387.55,
      Open: 4415.33,
      High: 4418.59,
      Low: 4382.77,
      Volume: "-",
    },
    {
      DATE: "2023-08-23",
      Close: 4436.01,
      Open: 4396.44,
      High: 4443.18,
      Low: 4396.44,
      Volume: "-",
    },
    {
      DATE: "2023-08-24",
      Close: 4376.31,
      Open: 4455.16,
      High: 4458.3,
      Low: 4375.55,
      Volume: "-",
    },
    {
      DATE: "2023-08-25",
      Close: 4405.71,
      Open: 4389.38,
      High: 4418.46,
      Low: 4356.29,
      Volume: "-",
    },
    {
      DATE: "2023-08-28",
      Close: 4433.31,
      Open: 4426.03,
      High: 4439.56,
      Low: 4414.98,
      Volume: "-",
    },
    {
      DATE: "2023-08-29",
      Close: 4497.63,
      Open: 4432.75,
      High: 4500.14,
      Low: 4431.68,
      Volume: "-",
    },
    {
      DATE: "2023-08-30",
      Close: 4514.87,
      Open: 4500.34,
      High: 4521.65,
      Low: 4493.59,
      Volume: "-",
    },
    {
      DATE: "2023-08-31",
      Close: 4507.66,
      Open: 4517.01,
      High: 4532.26,
      Low: 4507.39,
      Volume: "-",
    },
    {
      DATE: "2023-09-01",
      Close: 4515.77,
      Open: 4530.6,
      High: 4541.25,
      Low: 4501.35,
      Volume: "-",
    },
    {
      DATE: "2023-09-05",
      Close: 4496.83,
      Open: 4510.06,
      High: 4514.29,
      Low: 4496.01,
      Volume: "-",
    },
    {
      DATE: "2023-09-06",
      Close: 4465.48,
      Open: 4490.35,
      High: 4490.35,
      Low: 4442.38,
      Volume: "-",
    },
    {
      DATE: "2023-09-07",
      Close: 4451.14,
      Open: 4434.55,
      High: 4457.81,
      Low: 4430.46,
      Volume: "-",
    },
    {
      DATE: "2023-09-08",
      Close: 4457.49,
      Open: 4451.3,
      High: 4473.53,
      Low: 4448.38,
      Volume: "-",
    },
    {
      DATE: "2023-09-11",
      Close: 4487.46,
      Open: 4480.98,
      High: 4490.77,
      Low: 4467.89,
      Volume: "-",
    },
    {
      DATE: "2023-09-12",
      Close: 4461.9,
      Open: 4473.27,
      High: 4487.11,
      Low: 4456.83,
      Volume: "-",
    },
    {
      DATE: "2023-09-13",
      Close: 4467.44,
      Open: 4462.65,
      High: 4479.39,
      Low: 4453.52,
      Volume: "-",
    },
    {
      DATE: "2023-09-14",
      Close: 4505.1,
      Open: 4487.78,
      High: 4511.99,
      Low: 4478.69,
      Volume: "-",
    },
    {
      DATE: "2023-09-15",
      Close: 4450.32,
      Open: 4497.98,
      High: 4497.98,
      Low: 4447.21,
      Volume: "-",
    },
    {
      DATE: "2023-09-18",
      Close: 4453.53,
      Open: 4445.13,
      High: 4466.36,
      Low: 4442.11,
      Volume: "-",
    },
    {
      DATE: "2023-09-19",
      Close: 4443.95,
      Open: 4445.41,
      High: 4449.85,
      Low: 4416.61,
      Volume: "-",
    },
    {
      DATE: "2023-09-20",
      Close: 4402.2,
      Open: 4452.81,
      High: 4461.03,
      Low: 4401.38,
      Volume: "-",
    },
    {
      DATE: "2023-09-21",
      Close: 4330,
      Open: 4374.36,
      High: 4375.7,
      Low: 4329.17,
      Volume: "-",
    },
    {
      DATE: "2023-09-22",
      Close: 4320.06,
      Open: 4341.74,
      High: 4357.4,
      Low: 4316.49,
      Volume: "-",
    },
    {
      DATE: "2023-09-25",
      Close: 4337.44,
      Open: 4310.62,
      High: 4338.51,
      Low: 4302.7,
      Volume: "-",
    },
    {
      DATE: "2023-09-26",
      Close: 4273.53,
      Open: 4312.88,
      High: 4313.01,
      Low: 4265.98,
      Volume: "-",
    },
    {
      DATE: "2023-09-27",
      Close: 4274.51,
      Open: 4282.63,
      High: 4292.07,
      Low: 4238.63,
      Volume: "-",
    },
    {
      DATE: "2023-09-28",
      Close: 4299.7,
      Open: 4269.65,
      High: 4317.27,
      Low: 4264.38,
      Volume: "-",
    },
    {
      DATE: "2023-09-29",
      Close: 4288.05,
      Open: 4328.18,
      High: 4333.15,
      Low: 4274.86,
      Volume: "-",
    },
    {
      DATE: "2023-10-02",
      Close: 4288.39,
      Open: 4284.52,
      High: 4300.58,
      Low: 4260.21,
      Volume: "-",
    },
    {
      DATE: "2023-10-03",
      Close: 4229.45,
      Open: 4269.75,
      High: 4281.15,
      Low: 4216.45,
      Volume: "-",
    },
    {
      DATE: "2023-10-04",
      Close: 4263.75,
      Open: 4233.83,
      High: 4268.5,
      Low: 4220.48,
      Volume: "-",
    },
    {
      DATE: "2023-10-05",
      Close: 4258.19,
      Open: 4259.31,
      High: 4267.13,
      Low: 4225.91,
      Volume: "-",
    },
    {
      DATE: "2023-10-06",
      Close: 4308.5,
      Open: 4234.79,
      High: 4324.1,
      Low: 4219.55,
      Volume: "-",
    },
    {
      DATE: "2023-10-09",
      Close: 4335.66,
      Open: 4289.02,
      High: 4341.73,
      Low: 4283.79,
      Volume: "-",
    },
    {
      DATE: "2023-10-10",
      Close: 4358.24,
      Open: 4339.75,
      High: 4385.46,
      Low: 4339.64,
      Volume: "-",
    },
    {
      DATE: "2023-10-11",
      Close: 4376.95,
      Open: 4366.59,
      High: 4378.64,
      Low: 4345.34,
      Volume: "-",
    },
    {
      DATE: "2023-10-12",
      Close: 4349.61,
      Open: 4380.94,
      High: 4385.85,
      Low: 4325.43,
      Volume: "-",
    },
    {
      DATE: "2023-10-13",
      Close: 4327.78,
      Open: 4360.49,
      High: 4377.1,
      Low: 4311.97,
      Volume: "-",
    },
    {
      DATE: "2023-10-16",
      Close: 4373.63,
      Open: 4342.37,
      High: 4383.33,
      Low: 4342.37,
      Volume: "-",
    },
    {
      DATE: "2023-10-17",
      Close: 4373.2,
      Open: 4345.23,
      High: 4393.57,
      Low: 4337.54,
      Volume: "-",
    },
    {
      DATE: "2023-10-18",
      Close: 4314.6,
      Open: 4357.35,
      High: 4364.2,
      Low: 4303.84,
      Volume: "-",
    },
    {
      DATE: "2023-10-19",
      Close: 4278,
      Open: 4321.36,
      High: 4339.54,
      Low: 4269.69,
      Volume: "-",
    },
    {
      DATE: "2023-10-20",
      Close: 4224.16,
      Open: 4273.85,
      High: 4276.56,
      Low: 4223.03,
      Volume: "-",
    },
    {
      DATE: "2023-10-23",
      Close: 4217.04,
      Open: 4210.4,
      High: 4255.84,
      Low: 4189.22,
      Volume: "-",
    },
    {
      DATE: "2023-10-24",
      Close: 4247.68,
      Open: 4235.79,
      High: 4259.38,
      Low: 4219.43,
      Volume: "-",
    },
    {
      DATE: "2023-10-25",
      Close: 4186.77,
      Open: 4232.42,
      High: 4232.42,
      Low: 4181.42,
      Volume: "-",
    },
    {
      DATE: "2023-10-26",
      Close: 4137.23,
      Open: 4175.99,
      High: 4183.6,
      Low: 4127.9,
      Volume: "-",
    },
    {
      DATE: "2023-10-27",
      Close: 4117.37,
      Open: 4152.93,
      High: 4156.7,
      Low: 4103.78,
      Volume: "-",
    },
    {
      DATE: "2023-10-30",
      Close: 4166.82,
      Open: 4139.39,
      High: 4177.47,
      Low: 4132.94,
      Volume: "-",
    },
    {
      DATE: "2023-10-31",
      Close: 4193.8,
      Open: 4171.33,
      High: 4195.55,
      Low: 4153.12,
      Volume: "-",
    },
    {
      DATE: "2023-11-01",
      Close: 4237.86,
      Open: 4201.27,
      High: 4245.64,
      Low: 4197.74,
      Volume: "-",
    },
    {
      DATE: "2023-11-02",
      Close: 4317.78,
      Open: 4268.26,
      High: 4319.72,
      Low: 4268.26,
      Volume: "-",
    },
    {
      DATE: "2023-11-03",
      Close: 4358.34,
      Open: 4334.23,
      High: 4373.62,
      Low: 4334.23,
      Volume: "-",
    },
    {
      DATE: "2023-11-06",
      Close: 4365.98,
      Open: 4364.27,
      High: 4372.21,
      Low: 4347.53,
      Volume: "-",
    },
    {
      DATE: "2023-11-07",
      Close: 4378.38,
      Open: 4366.21,
      High: 4386.26,
      Low: 4355.41,
      Volume: "-",
    },
    {
      DATE: "2023-11-08",
      Close: 4382.78,
      Open: 4384.37,
      High: 4391.2,
      Low: 4359.76,
      Volume: "-",
    },
    {
      DATE: "2023-11-09",
      Close: 4347.35,
      Open: 4391.41,
      High: 4393.4,
      Low: 4343.94,
      Volume: "-",
    },
    {
      DATE: "2023-11-10",
      Close: 4415.24,
      Open: 4364.15,
      High: 4418.03,
      Low: 4353.34,
      Volume: "-",
    },
    {
      DATE: "2023-11-13",
      Close: 4411.55,
      Open: 4406.66,
      High: 4421.76,
      Low: 4393.82,
      Volume: "-",
    },
    {
      DATE: "2023-11-14",
      Close: 4495.7,
      Open: 4458.97,
      High: 4508.67,
      Low: 4458.97,
      Volume: "-",
    },
    {
      DATE: "2023-11-15",
      Close: 4502.88,
      Open: 4505.3,
      High: 4521.17,
      Low: 4495.31,
      Volume: "-",
    },
    {
      DATE: "2023-11-16",
      Close: 4508.24,
      Open: 4497.08,
      High: 4511.99,
      Low: 4487.83,
      Volume: "-",
    },
    {
      DATE: "2023-11-17",
      Close: 4514.02,
      Open: 4509.55,
      High: 4520.12,
      Low: 4499.66,
      Volume: "-",
    },
    {
      DATE: "2023-11-20",
      Close: 4547.38,
      Open: 4511.7,
      High: 4557.11,
      Low: 4510.36,
      Volume: "-",
    },
    {
      DATE: "2023-11-21",
      Close: 4538.19,
      Open: 4538.77,
      High: 4542.14,
      Low: 4525.51,
      Volume: "-",
    },
    {
      DATE: "2023-11-22",
      Close: 4556.62,
      Open: 4553.04,
      High: 4568.43,
      Low: 4545.05,
      Volume: "-",
    },
    {
      DATE: "2023-11-24",
      Close: 4559.34,
      Open: 4555.84,
      High: 4560.31,
      Low: 4552.8,
      Volume: "-",
    },
    {
      DATE: "2023-11-27",
      Close: 4550.43,
      Open: 4554.86,
      High: 4560.52,
      Low: 4546.32,
      Volume: "-",
    },
    {
      DATE: "2023-11-28",
      Close: 4554.89,
      Open: 4545.55,
      High: 4568.14,
      Low: 4540.51,
      Volume: "-",
    },
    {
      DATE: "2023-11-29",
      Close: 4550.58,
      Open: 4571.84,
      High: 4587.64,
      Low: 4547.15,
      Volume: "-",
    },
    {
      DATE: "2023-11-30",
      Close: 4567.8,
      Open: 4554.87,
      High: 4569.89,
      Low: 4537.24,
      Volume: "-",
    },
    {
      DATE: "2023-12-01",
      Close: 4594.63,
      Open: 4559.43,
      High: 4599.39,
      Low: 4554.71,
      Volume: "-",
    },
    {
      DATE: "2023-12-04",
      Close: 4569.78,
      Open: 4564.37,
      High: 4572.37,
      Low: 4546.72,
      Volume: "-",
    },
    {
      DATE: "2023-12-05",
      Close: 4567.18,
      Open: 4557.25,
      High: 4578.56,
      Low: 4551.68,
      Volume: "-",
    },
    {
      DATE: "2023-12-06",
      Close: 4549.34,
      Open: 4586.23,
      High: 4590.74,
      Low: 4546.5,
      Volume: "-",
    },
    {
      DATE: "2023-12-07",
      Close: 4585.59,
      Open: 4568.84,
      High: 4590.92,
      Low: 4565.22,
      Volume: "-",
    },
    {
      DATE: "2023-12-08",
      Close: 4604.37,
      Open: 4576.2,
      High: 4609.23,
      Low: 4574.06,
      Volume: "-",
    },
    {
      DATE: "2023-12-11",
      Close: 4622.44,
      Open: 4593.39,
      High: 4623.71,
      Low: 4593.39,
      Volume: "-",
    },
  ],
};
export const chartData = {
  shortName: "AVGO",
  name: "Broadcom Inc",
  desc: "EOD Quote",
  table: {
    DATE: "2023-12-11",
    Open: 957.01,
    "Day High": 1039.44,
    "Day Low": 956.43,
    "Prev Close": 944.3,
    "%CHG": "9.00",
  },
  dataList: [
    {
      DATE: "2023-01-03",
      Close: 553.48,
      Open: 565,
      High: 567.22,
      Low: 550.88,
      Volume: "-",
    },
    {
      DATE: "2023-01-04",
      Close: 560.24,
      Open: 562.99,
      High: 568.01,
      Low: 556.15,
      Volume: "-",
    },
    {
      DATE: "2023-01-05",
      Close: 555.02,
      Open: 555.71,
      High: 559.84,
      Low: 551.35,
      Volume: "-",
    },
    {
      DATE: "2023-01-06",
      Close: 588.43,
      Open: 563.12,
      High: 590.94,
      Low: 562.8,
      Volume: "-",
    },
    {
      DATE: "2023-01-09",
      Close: 576.89,
      Open: 592.3,
      High: 601.61,
      Low: 560.56,
      Volume: "-",
    },
    {
      DATE: "2023-01-10",
      Close: 574.93,
      Open: 571.79,
      High: 575.13,
      Low: 550,
      Volume: "-",
    },
    {
      DATE: "2023-01-11",
      Close: 578.14,
      Open: 572.61,
      High: 578.32,
      Low: 567,
      Volume: "-",
    },
    {
      DATE: "2023-01-12",
      Close: 581.94,
      Open: 574.76,
      High: 585.03,
      Low: 573.84,
      Volume: "-",
    },
    {
      DATE: "2023-01-13",
      Close: 579,
      Open: 577,
      High: 581.61,
      Low: 576.87,
      Volume: "-",
    },
    {
      DATE: "2023-01-17",
      Close: 579.24,
      Open: 574.9,
      High: 585.04,
      Low: 574.87,
      Volume: "-",
    },
    {
      DATE: "2023-01-18",
      Close: 574.29,
      Open: 583.21,
      High: 587.56,
      Low: 573.82,
      Volume: "-",
    },
    {
      DATE: "2023-01-19",
      Close: 563.22,
      Open: 568.68,
      High: 569.84,
      Low: 560.38,
      Volume: "-",
    },
    {
      DATE: "2023-01-20",
      Close: 570.78,
      Open: 563.03,
      High: 571.36,
      Low: 559.4,
      Volume: "-",
    },
    {
      DATE: "2023-01-23",
      Close: 581.63,
      Open: 572,
      High: 584.63,
      Low: 569.885,
      Volume: "-",
    },
    {
      DATE: "2023-01-24",
      Close: 585.03,
      Open: 578.44,
      High: 586.17,
      Low: 575.85,
      Volume: "-",
    },
    {
      DATE: "2023-01-25",
      Close: 585.68,
      Open: 577.67,
      High: 586.97,
      Low: 576.21,
      Volume: "-",
    },
    {
      DATE: "2023-01-26",
      Close: 598.58,
      Open: 590.41,
      High: 600.39,
      Low: 586.52,
      Volume: "-",
    },
    {
      DATE: "2023-01-27",
      Close: 590.99,
      Open: 593.32,
      High: 598.99,
      Low: 590.19,
      Volume: "-",
    },
    {
      DATE: "2023-01-30",
      Close: 581.45,
      Open: 583,
      High: 589.14,
      Low: 579.76,
      Volume: "-",
    },
    {
      DATE: "2023-01-31",
      Close: 585.01,
      Open: 581.04,
      High: 587.11,
      Low: 580.9,
      Volume: "-",
    },
    {
      DATE: "2023-02-01",
      Close: 602.75,
      Open: 583.57,
      High: 608.22,
      Low: 582.99,
      Volume: "-",
    },
    {
      DATE: "2023-02-02",
      Close: 605.77,
      Open: 607.63,
      High: 613.07,
      Low: 599.75,
      Volume: "-",
    },
    {
      DATE: "2023-02-03",
      Close: 597.62,
      Open: 598,
      High: 607.83,
      Low: 596.27,
      Volume: "-",
    },
    {
      DATE: "2023-02-06",
      Close: 601.3,
      Open: 593.34,
      High: 603.12,
      Low: 592.26,
      Volume: "-",
    },
    {
      DATE: "2023-02-07",
      Close: 614.45,
      Open: 602.52,
      High: 617,
      Low: 599.8,
      Volume: "-",
    },
    {
      DATE: "2023-02-08",
      Close: 601.71,
      Open: 606.68,
      High: 610,
      Low: 600.66,
      Volume: "-",
    },
    {
      DATE: "2023-02-09",
      Close: 599.41,
      Open: 612.6,
      High: 614.66,
      Low: 595.65,
      Volume: "-",
    },
    {
      DATE: "2023-02-10",
      Close: 593.25,
      Open: 596.31,
      High: 598,
      Low: 589.63,
      Volume: "-",
    },
    {
      DATE: "2023-02-13",
      Close: 601.12,
      Open: 595,
      High: 601.48,
      Low: 594,
      Volume: "-",
    },
    {
      DATE: "2023-02-14",
      Close: 602.31,
      Open: 594,
      High: 605.52,
      Low: 593.315,
      Volume: "-",
    },
    {
      DATE: "2023-02-15",
      Close: 607.69,
      Open: 598.86,
      High: 608.28,
      Low: 596.8,
      Volume: "-",
    },
    {
      DATE: "2023-02-16",
      Close: 600.54,
      Open: 599.55,
      High: 608.81,
      Low: 599.55,
      Volume: "-",
    },
    {
      DATE: "2023-02-17",
      Close: 595.59,
      Open: 600,
      High: 600.85,
      Low: 592.8,
      Volume: "-",
    },
    {
      DATE: "2023-02-21",
      Close: 581.54,
      Open: 590,
      High: 593.09,
      Low: 579.98,
      Volume: "-",
    },
    {
      DATE: "2023-02-22",
      Close: 576.17,
      Open: 582.25,
      High: 582.99,
      Low: 572.12,
      Volume: "-",
    },
    {
      DATE: "2023-02-23",
      Close: 583.8,
      Open: 585.25,
      High: 585.75,
      Low: 573.68,
      Volume: "-",
    },
    {
      DATE: "2023-02-24",
      Close: 577.75,
      Open: 577.53,
      High: 580.05,
      Low: 573.7,
      Volume: "-",
    },
    {
      DATE: "2023-02-27",
      Close: 585.45,
      Open: 585.87,
      High: 589.79,
      Low: 584.46,
      Volume: "-",
    },
    {
      DATE: "2023-02-28",
      Close: 594.29,
      Open: 585.56,
      High: 598.51,
      Low: 582.21,
      Volume: "-",
    },
    {
      DATE: "2023-03-01",
      Close: 593.57,
      Open: 594,
      High: 598.1,
      Low: 590.58,
      Volume: "-",
    },
    {
      DATE: "2023-03-02",
      Close: 598.65,
      Open: 589.39,
      High: 600.87,
      Low: 586.31,
      Volume: "-",
    },
    {
      DATE: "2023-03-03",
      Close: 632.76,
      Open: 617.49,
      High: 635.73,
      Low: 615.9,
      Volume: "-",
    },
    {
      DATE: "2023-03-06",
      Close: 632.92,
      Open: 635,
      High: 644,
      Low: 631.78,
      Volume: "-",
    },
    {
      DATE: "2023-03-07",
      Close: 625.15,
      Open: 634.87,
      High: 635.41,
      Low: 623.51,
      Volume: "-",
    },
    {
      DATE: "2023-03-08",
      Close: 632.26,
      Open: 627.78,
      High: 632.65,
      Low: 624.075,
      Volume: "-",
    },
    {
      DATE: "2023-03-09",
      Close: 622.52,
      Open: 630.08,
      High: 642.27,
      Low: 621.93,
      Volume: "-",
    },
    {
      DATE: "2023-03-10",
      Close: 614.83,
      Open: 628.19,
      High: 630,
      Low: 613.01,
      Volume: "-",
    },
    {
      DATE: "2023-03-13",
      Close: 616.47,
      Open: 607.09,
      High: 624.27,
      Low: 607.09,
      Volume: "-",
    },
    {
      DATE: "2023-03-14",
      Close: 632.46,
      Open: 623.39,
      High: 633.37,
      Low: 618.6,
      Volume: "-",
    },
    {
      DATE: "2023-03-15",
      Close: 626.04,
      Open: 627.67,
      High: 630,
      Low: 616.24,
      Volume: "-",
    },
    {
      DATE: "2023-03-16",
      Close: 636.5,
      Open: 618.7,
      High: 637,
      Low: 617.97,
      Volume: "-",
    },
    {
      DATE: "2023-03-17",
      Close: 630.97,
      Open: 636.5,
      High: 639,
      Low: 627.15,
      Volume: "-",
    },
    {
      DATE: "2023-03-20",
      Close: 643.71,
      Open: 632.74,
      High: 644.74,
      Low: 631.94,
      Volume: "-",
    },
    {
      DATE: "2023-03-21",
      Close: 636.75,
      Open: 643.09,
      High: 646.46,
      Low: 634.53,
      Volume: "-",
    },
    {
      DATE: "2023-03-22",
      Close: 630.92,
      Open: 636.9,
      High: 648.04,
      Low: 630.67,
      Volume: "-",
    },
    {
      DATE: "2023-03-23",
      Close: 639.23,
      Open: 638.9,
      High: 648.12,
      Low: 631.53,
      Volume: "-",
    },
    {
      DATE: "2023-03-24",
      Close: 636.17,
      Open: 638.03,
      High: 639.26,
      Low: 628.62,
      Volume: "-",
    },
    {
      DATE: "2023-03-27",
      Close: 626.84,
      Open: 639,
      High: 639.1,
      Low: 626,
      Volume: "-",
    },
    {
      DATE: "2023-03-28",
      Close: 624.7,
      Open: 625.23,
      High: 626.32,
      Low: 618.88,
      Volume: "-",
    },
    {
      DATE: "2023-03-29",
      Close: 625.5,
      Open: 632.78,
      High: 633.89,
      Low: 624.64,
      Volume: "-",
    },
    {
      DATE: "2023-03-30",
      Close: 633.75,
      Open: 632.73,
      High: 636.04,
      Low: 629.3,
      Volume: "-",
    },
    {
      DATE: "2023-03-31",
      Close: 641.54,
      Open: 631.24,
      High: 642.17,
      Low: 626.79,
      Volume: "-",
    },
    {
      DATE: "2023-04-03",
      Close: 642.47,
      Open: 639,
      High: 643.86,
      Low: 636.48,
      Volume: "-",
    },
    {
      DATE: "2023-04-04",
      Close: 634.41,
      Open: 643.15,
      High: 644,
      Low: 632,
      Volume: "-",
    },
    {
      DATE: "2023-04-05",
      Close: 629.01,
      Open: 631.14,
      High: 631.6,
      Low: 625.7,
      Volume: "-",
    },
    {
      DATE: "2023-04-06",
      Close: 622.64,
      Open: 624.16,
      High: 628.33,
      Low: 619.32,
      Volume: "-",
    },
    {
      DATE: "2023-04-10",
      Close: 627.39,
      Open: 618.05,
      High: 627.65,
      Low: 616.72,
      Volume: "-",
    },
    {
      DATE: "2023-04-11",
      Close: 621.57,
      Open: 630.78,
      High: 630.88,
      Low: 620.82,
      Volume: "-",
    },
    {
      DATE: "2023-04-12",
      Close: 616.7,
      Open: 627.34,
      High: 627.34,
      Low: 616.26,
      Volume: "-",
    },
    {
      DATE: "2023-04-13",
      Close: 624.24,
      Open: 619.07,
      High: 626.5,
      Low: 617.57,
      Volume: "-",
    },
    {
      DATE: "2023-04-14",
      Close: 619.54,
      Open: 620.48,
      High: 627.9,
      Low: 615.21,
      Volume: "-",
    },
    {
      DATE: "2023-04-17",
      Close: 627.36,
      Open: 618.61,
      High: 628.15,
      Low: 617.87,
      Volume: "-",
    },
    {
      DATE: "2023-04-18",
      Close: 632.32,
      Open: 631.62,
      High: 635.17,
      Low: 627.36,
      Volume: "-",
    },
    {
      DATE: "2023-04-19",
      Close: 634.5,
      Open: 627.525,
      High: 636.74,
      Low: 625.55,
      Volume: "-",
    },
    {
      DATE: "2023-04-20",
      Close: 633.02,
      Open: 627.86,
      High: 642.715,
      Low: 627.62,
      Volume: "-",
    },
    {
      DATE: "2023-04-21",
      Close: 632.9,
      Open: 630.6,
      High: 633.75,
      Low: 622.04,
      Volume: "-",
    },
    {
      DATE: "2023-04-24",
      Close: 634.54,
      Open: 633.64,
      High: 638.85,
      Low: 631.81,
      Volume: "-",
    },
    {
      DATE: "2023-04-25",
      Close: 622.02,
      Open: 633.99,
      High: 635.75,
      Low: 621.78,
      Volume: "-",
    },
    {
      DATE: "2023-04-26",
      Close: 616.19,
      Open: 620.47,
      High: 622.87,
      Low: 613.6,
      Volume: "-",
    },
    {
      DATE: "2023-04-27",
      Close: 618.41,
      Open: 616.19,
      High: 620.06,
      Low: 603.39,
      Volume: "-",
    },
    {
      DATE: "2023-04-28",
      Close: 626.5,
      Open: 619.07,
      High: 626.78,
      Low: 614.61,
      Volume: "-",
    },
    {
      DATE: "2023-05-01",
      Close: 637.95,
      Open: 626.5,
      High: 638.95,
      Low: 626.2,
      Volume: "-",
    },
    {
      DATE: "2023-05-02",
      Close: 612.34,
      Open: 625,
      High: 626.49,
      Low: 605.07,
      Volume: "-",
    },
    {
      DATE: "2023-05-03",
      Close: 613.2,
      Open: 616.9,
      High: 621.87,
      Low: 612.4,
      Volume: "-",
    },
    {
      DATE: "2023-05-04",
      Close: 610.16,
      Open: 610,
      High: 613.96,
      Low: 601.29,
      Volume: "-",
    },
    {
      DATE: "2023-05-05",
      Close: 630.12,
      Open: 617.43,
      High: 631.33,
      Low: 613.38,
      Volume: "-",
    },
    {
      DATE: "2023-05-08",
      Close: 629.06,
      Open: 629.78,
      High: 630.375,
      Low: 620.98,
      Volume: "-",
    },
    {
      DATE: "2023-05-09",
      Close: 618.51,
      Open: 622.73,
      High: 623.97,
      Low: 615.86,
      Volume: "-",
    },
    {
      DATE: "2023-05-10",
      Close: 626.27,
      Open: 622.06,
      High: 628,
      Low: 618.3,
      Volume: "-",
    },
    {
      DATE: "2023-05-11",
      Close: 627.67,
      Open: 626.58,
      High: 628.1,
      Low: 617.99,
      Volume: "-",
    },
    {
      DATE: "2023-05-12",
      Close: 631.15,
      Open: 628.38,
      High: 632.66,
      Low: 624.39,
      Volume: "-",
    },
    {
      DATE: "2023-05-15",
      Close: 639.8,
      Open: 631.87,
      High: 640.02,
      Low: 628.66,
      Volume: "-",
    },
    {
      DATE: "2023-05-16",
      Close: 641.44,
      Open: 639.5,
      High: 646.73,
      Low: 639.19,
      Volume: "-",
    },
    {
      DATE: "2023-05-17",
      Close: 657.47,
      Open: 647.35,
      High: 660.81,
      Low: 644.7,
      Volume: "-",
    },
    {
      DATE: "2023-05-18",
      Close: 677.9,
      Open: 656,
      High: 679.27,
      Low: 656,
      Volume: "-",
    },
    {
      DATE: "2023-05-19",
      Close: 682.25,
      Open: 680,
      High: 684.95,
      Low: 679,
      Volume: "-",
    },
    {
      DATE: "2023-05-22",
      Close: 678.37,
      Open: 681.4,
      High: 684.68,
      Low: 674.13,
      Volume: "-",
    },
    {
      DATE: "2023-05-23",
      Close: 686.5,
      Open: 690.64,
      High: 698.84,
      Low: 682.27,
      Volume: "-",
    },
    {
      DATE: "2023-05-24",
      Close: 679.53,
      Open: 680.66,
      High: 684.12,
      Low: 676.56,
      Volume: "-",
    },
    {
      DATE: "2023-05-25",
      Close: 728.8,
      Open: 699.41,
      High: 732.28,
      Low: 691.065,
      Volume: "-",
    },
    {
      DATE: "2023-05-26",
      Close: 812.73,
      Open: 747.87,
      High: 814.97,
      Low: 747.02,
      Volume: "-",
    },
    {
      DATE: "2023-05-30",
      Close: 803.34,
      Open: 835.77,
      High: 920.56,
      Low: 799.02,
      Volume: "-",
    },
    {
      DATE: "2023-05-31",
      Close: 807.96,
      Open: 794.9,
      High: 820.98,
      Low: 790.2,
      Volume: "-",
    },
    {
      DATE: "2023-06-01",
      Close: 789.95,
      Open: 800.5,
      High: 805.71,
      Low: 785.25,
      Volume: "-",
    },
    {
      DATE: "2023-06-02",
      Close: 812,
      Open: 790.64,
      High: 823.61,
      Low: 787.57,
      Volume: "-",
    },
    {
      DATE: "2023-06-05",
      Close: 802.3,
      Open: 809.2,
      High: 809.2,
      Low: 794.815,
      Volume: "-",
    },
    {
      DATE: "2023-06-06",
      Close: 790,
      Open: 802,
      High: 802,
      Low: 776.57,
      Volume: "-",
    },
    {
      DATE: "2023-06-07",
      Close: 792.63,
      Open: 789.82,
      High: 805.45,
      Low: 788,
      Volume: "-",
    },
    {
      DATE: "2023-06-08",
      Close: 804.2,
      Open: 794.91,
      High: 805,
      Low: 788.78,
      Volume: "-",
    },
    {
      DATE: "2023-06-09",
      Close: 804.62,
      Open: 805.8,
      High: 817.67,
      Low: 803.99,
      Volume: "-",
    },
    {
      DATE: "2023-06-12",
      Close: 855.36,
      Open: 812.67,
      High: 857.77,
      Low: 812.13,
      Volume: "-",
    },
    {
      DATE: "2023-06-13",
      Close: 851.12,
      Open: 861.13,
      High: 863,
      Low: 842.16,
      Volume: "-",
    },
    {
      DATE: "2023-06-14",
      Close: 886.18,
      Open: 855.82,
      High: 888.54,
      Low: 847.22,
      Volume: "-",
    },
    {
      DATE: "2023-06-15",
      Close: 883.43,
      Open: 884.41,
      High: 887.75,
      Low: 871.43,
      Volume: "-",
    },
    {
      DATE: "2023-06-16",
      Close: 868.11,
      Open: 889.84,
      High: 889.84,
      Low: 865.81,
      Volume: "-",
    },
    {
      DATE: "2023-06-20",
      Close: 868.03,
      Open: 862.66,
      High: 877.07,
      Low: 862,
      Volume: "-",
    },
    {
      DATE: "2023-06-21",
      Close: 847.66,
      Open: 860,
      High: 865.5,
      Low: 845.18,
      Volume: "-",
    },
    {
      DATE: "2023-06-22",
      Close: 842.43,
      Open: 845.09,
      High: 847.88,
      Low: 835.41,
      Volume: "-",
    },
    {
      DATE: "2023-06-23",
      Close: 822.15,
      Open: 834.01,
      High: 836.02,
      Low: 818.92,
      Volume: "-",
    },
    {
      DATE: "2023-06-26",
      Close: 821.63,
      Open: 825,
      High: 837,
      Low: 821.22,
      Volume: "-",
    },
    {
      DATE: "2023-06-27",
      Close: 848.4,
      Open: 828.68,
      High: 849.69,
      Low: 821.28,
      Volume: "-",
    },
    {
      DATE: "2023-06-28",
      Close: 847.94,
      Open: 838.73,
      High: 858.33,
      Low: 838,
      Volume: "-",
    },
    {
      DATE: "2023-06-29",
      Close: 862.57,
      Open: 854.45,
      High: 862.83,
      Low: 846.41,
      Volume: "-",
    },
    {
      DATE: "2023-06-30",
      Close: 867.43,
      Open: 868.52,
      High: 874.57,
      Low: 864.48,
      Volume: "-",
    },
    {
      DATE: "2023-07-03",
      Close: 876.44,
      Open: 868.62,
      High: 876.66,
      Low: 864.99,
      Volume: "-",
    },
    {
      DATE: "2023-07-05",
      Close: 861.86,
      Open: 867.4,
      High: 876.79,
      Low: 861.75,
      Volume: "-",
    },
    {
      DATE: "2023-07-06",
      Close: 848,
      Open: 845,
      High: 853.5,
      Low: 844.33,
      Volume: "-",
    },
    {
      DATE: "2023-07-07",
      Close: 846.75,
      Open: 850.43,
      High: 857.87,
      Low: 844.66,
      Volume: "-",
    },
    {
      DATE: "2023-07-10",
      Close: 877.73,
      Open: 848.28,
      High: 879.17,
      Low: 848.28,
      Volume: "-",
    },
    {
      DATE: "2023-07-11",
      Close: 882.05,
      Open: 881.52,
      High: 883,
      Low: 864.64,
      Volume: "-",
    },
    {
      DATE: "2023-07-12",
      Close: 889.95,
      Open: 889,
      High: 897.34,
      Low: 882,
      Volume: "-",
    },
    {
      DATE: "2023-07-13",
      Close: 890.36,
      Open: 898.94,
      High: 898.94,
      Low: 878.48,
      Volume: "-",
    },
    {
      DATE: "2023-07-14",
      Close: 888.58,
      Open: 886.16,
      High: 903.09,
      Low: 886.16,
      Volume: "-",
    },
    {
      DATE: "2023-07-17",
      Close: 910.35,
      Open: 889.78,
      High: 912.78,
      Low: 889.78,
      Volume: "-",
    },
    {
      DATE: "2023-07-18",
      Close: 903.43,
      Open: 905.98,
      High: 909.61,
      Low: 898.37,
      Volume: "-",
    },
    {
      DATE: "2023-07-19",
      Close: 901.37,
      Open: 897.27,
      High: 905.81,
      Low: 886.4,
      Volume: "-",
    },
    {
      DATE: "2023-07-20",
      Close: 888.34,
      Open: 891.79,
      High: 906.14,
      Low: 886.03,
      Volume: "-",
    },
    {
      DATE: "2023-07-21",
      Close: 896.75,
      Open: 904.49,
      High: 911.11,
      Low: 894,
      Volume: "-",
    },
    {
      DATE: "2023-07-24",
      Close: 901.59,
      Open: 900.8,
      High: 905.2,
      Low: 894.36,
      Volume: "-",
    },
    {
      DATE: "2023-07-25",
      Close: 917.99,
      Open: 900.62,
      High: 922.98,
      Low: 900.62,
      Volume: "-",
    },
    {
      DATE: "2023-07-26",
      Close: 893.09,
      Open: 909,
      High: 909.67,
      Low: 887.72,
      Volume: "-",
    },
    {
      DATE: "2023-07-27",
      Close: 893.53,
      Open: 908.5,
      High: 909.67,
      Low: 886.81,
      Volume: "-",
    },
    {
      DATE: "2023-07-28",
      Close: 899.79,
      Open: 899.32,
      High: 903.295,
      Low: 894.26,
      Volume: "-",
    },
    {
      DATE: "2023-07-31",
      Close: 898.65,
      Open: 897.5,
      High: 901,
      Low: 891.53,
      Volume: "-",
    },
    {
      DATE: "2023-08-01",
      Close: 920,
      Open: 898.98,
      High: 920.61,
      Low: 898.15,
      Volume: "-",
    },
    {
      DATE: "2023-08-02",
      Close: 892.3,
      Open: 912.3,
      High: 913,
      Low: 890.29,
      Volume: "-",
    },
    {
      DATE: "2023-08-03",
      Close: 884.98,
      Open: 886.62,
      High: 895.33,
      Low: 881.13,
      Volume: "-",
    },
    {
      DATE: "2023-08-04",
      Close: 881.65,
      Open: 884.98,
      High: 893.62,
      Low: 873.7,
      Volume: "-",
    },
    {
      DATE: "2023-08-07",
      Close: 897.06,
      Open: 886.92,
      High: 897.35,
      Low: 885.53,
      Volume: "-",
    },
    {
      DATE: "2023-08-08",
      Close: 883.16,
      Open: 889.01,
      High: 889.81,
      Low: 873.4,
      Volume: "-",
    },
    {
      DATE: "2023-08-09",
      Close: 850.73,
      Open: 882.72,
      High: 882.72,
      Low: 848.81,
      Volume: "-",
    },
    {
      DATE: "2023-08-10",
      Close: 842.9,
      Open: 853.12,
      High: 861.26,
      Low: 837.36,
      Volume: "-",
    },
    {
      DATE: "2023-08-11",
      Close: 829.76,
      Open: 834.01,
      High: 836.37,
      Low: 823.67,
      Volume: "-",
    },
    {
      DATE: "2023-08-14",
      Close: 854.1,
      Open: 831.13,
      High: 854.18,
      Low: 827.38,
      Volume: "-",
    },
    {
      DATE: "2023-08-15",
      Close: 842.52,
      Open: 849.21,
      High: 854.17,
      Low: 836.56,
      Volume: "-",
    },
    {
      DATE: "2023-08-16",
      Close: 832.99,
      Open: 847.79,
      High: 854.29,
      Low: 832,
      Volume: "-",
    },
    {
      DATE: "2023-08-17",
      Close: 827.1,
      Open: 836.51,
      High: 839.1,
      Low: 827.01,
      Volume: "-",
    },
    {
      DATE: "2023-08-18",
      Close: 825.84,
      Open: 820,
      High: 828.17,
      Low: 812.34,
      Volume: "-",
    },
    {
      DATE: "2023-08-21",
      Close: 865.14,
      Open: 834.06,
      High: 867.22,
      Low: 832.22,
      Volume: "-",
    },
    {
      DATE: "2023-08-22",
      Close: 855.79,
      Open: 873.41,
      High: 874,
      Low: 851.02,
      Volume: "-",
    },
    {
      DATE: "2023-08-23",
      Close: 876.58,
      Open: 850.77,
      High: 878.19,
      Low: 850.28,
      Volume: "-",
    },
    {
      DATE: "2023-08-24",
      Close: 854.46,
      Open: 902.35,
      High: 909.5,
      Low: 852.97,
      Volume: "-",
    },
    {
      DATE: "2023-08-25",
      Close: 851.82,
      Open: 857.02,
      High: 869,
      Low: 837.78,
      Volume: "-",
    },
    {
      DATE: "2023-08-28",
      Close: 861.08,
      Open: 856.39,
      High: 863.12,
      Low: 847.11,
      Volume: "-",
    },
    {
      DATE: "2023-08-29",
      Close: 889.93,
      Open: 858.4,
      High: 892.72,
      Low: 856.48,
      Volume: "-",
    },
    {
      DATE: "2023-08-30",
      Close: 892.28,
      Open: 892.39,
      High: 898.47,
      Low: 879.77,
      Volume: "-",
    },
    {
      DATE: "2023-08-31",
      Close: 922.89,
      Open: 898.01,
      High: 923.66,
      Low: 893.77,
      Volume: "-",
    },
    {
      DATE: "2023-09-01",
      Close: 872.52,
      Open: 900.95,
      High: 901.22,
      Low: 864.87,
      Volume: "-",
    },
    {
      DATE: "2023-09-05",
      Close: 872.17,
      Open: 869.51,
      High: 883,
      Low: 867.32,
      Volume: "-",
    },
    {
      DATE: "2023-09-06",
      Close: 872.27,
      Open: 872.5,
      High: 877.24,
      Low: 867,
      Volume: "-",
    },
    {
      DATE: "2023-09-07",
      Close: 857.03,
      Open: 859.5,
      High: 861.51,
      Low: 841.08,
      Volume: "-",
    },
    {
      DATE: "2023-09-08",
      Close: 857.55,
      Open: 855,
      High: 860.83,
      Low: 850.29,
      Volume: "-",
    },
    {
      DATE: "2023-09-11",
      Close: 859.14,
      Open: 868.77,
      High: 868.77,
      Low: 845.65,
      Volume: "-",
    },
    {
      DATE: "2023-09-12",
      Close: 844.52,
      Open: 850.24,
      High: 858.16,
      Low: 841.86,
      Volume: "-",
    },
    {
      DATE: "2023-09-13",
      Close: 852.93,
      Open: 846.62,
      High: 858.96,
      Low: 844.25,
      Volume: "-",
    },
    {
      DATE: "2023-09-14",
      Close: 871.64,
      Open: 859.03,
      High: 876.67,
      Low: 855.84,
      Volume: "-",
    },
    {
      DATE: "2023-09-15",
      Close: 851.68,
      Open: 868.16,
      High: 868.16,
      Low: 843,
      Volume: "-",
    },
    {
      DATE: "2023-09-18",
      Close: 850,
      Open: 841.05,
      High: 856,
      Low: 840,
      Volume: "-",
    },
    {
      DATE: "2023-09-19",
      Close: 849.2,
      Open: 845.99,
      High: 851.03,
      Low: 838.69,
      Volume: "-",
    },
    {
      DATE: "2023-09-20",
      Close: 830.57,
      Open: 849.99,
      High: 849.99,
      Low: 830.35,
      Volume: "-",
    },
    {
      DATE: "2023-09-21",
      Close: 808.36,
      Open: 797,
      High: 822.42,
      Low: 795.4,
      Volume: "-",
    },
    {
      DATE: "2023-09-22",
      Close: 829.08,
      Open: 811.24,
      High: 830.35,
      Low: 811,
      Volume: "-",
    },
    {
      DATE: "2023-09-25",
      Close: 833.89,
      Open: 828,
      High: 837.88,
      Low: 824.45,
      Volume: "-",
    },
    {
      DATE: "2023-09-26",
      Close: 816.19,
      Open: 829.17,
      High: 830.05,
      Low: 811.21,
      Volume: "-",
    },
    {
      DATE: "2023-09-27",
      Close: 816.81,
      Open: 819.26,
      High: 823.6,
      Low: 804.57,
      Volume: "-",
    },
    {
      DATE: "2023-09-28",
      Close: 832,
      Open: 820.17,
      High: 838.84,
      Low: 816,
      Volume: "-",
    },
    {
      DATE: "2023-09-29",
      Close: 830.58,
      Open: 836.45,
      High: 843.98,
      Low: 822.91,
      Volume: "-",
    },
    {
      DATE: "2023-10-02",
      Close: 834.95,
      Open: 827.68,
      High: 838.47,
      Low: 824.06,
      Volume: "-",
    },
    {
      DATE: "2023-10-03",
      Close: 814.83,
      Open: 827,
      High: 835.75,
      Low: 808.93,
      Volume: "-",
    },
    {
      DATE: "2023-10-04",
      Close: 823.81,
      Open: 820.33,
      High: 830.39,
      Low: 816.59,
      Volume: "-",
    },
    {
      DATE: "2023-10-05",
      Close: 823.86,
      Open: 820.11,
      High: 828.21,
      Low: 816.06,
      Volume: "-",
    },
    {
      DATE: "2023-10-06",
      Close: 845.26,
      Open: 819.4,
      High: 848.36,
      Low: 812,
      Volume: "-",
    },
    {
      DATE: "2023-10-09",
      Close: 855.88,
      Open: 840.46,
      High: 856.54,
      Low: 837.83,
      Volume: "-",
    },
    {
      DATE: "2023-10-10",
      Close: 858.41,
      Open: 857.15,
      High: 872.23,
      Low: 855.84,
      Volume: "-",
    },
    {
      DATE: "2023-10-11",
      Close: 874.56,
      Open: 859.71,
      High: 875.17,
      Low: 857.705,
      Volume: "-",
    },
    {
      DATE: "2023-10-12",
      Close: 905.6,
      Open: 876.43,
      High: 917.72,
      Low: 876.43,
      Volume: "-",
    },
    {
      DATE: "2023-10-13",
      Close: 883.18,
      Open: 909,
      High: 925.91,
      Low: 882.13,
      Volume: "-",
    },
    {
      DATE: "2023-10-16",
      Close: 902.57,
      Open: 890.97,
      High: 915.115,
      Low: 890.97,
      Volume: "-",
    },
    {
      DATE: "2023-10-17",
      Close: 884.4,
      Open: 885.15,
      High: 891.67,
      Low: 867.21,
      Volume: "-",
    },
    {
      DATE: "2023-10-18",
      Close: 887.03,
      Open: 880,
      High: 895.285,
      Low: 876,
      Volume: "-",
    },
    {
      DATE: "2023-10-19",
      Close: 867.83,
      Open: 887.02,
      High: 889.39,
      Low: 865.83,
      Volume: "-",
    },
    {
      DATE: "2023-10-20",
      Close: 853.63,
      Open: 874.9,
      High: 874.9,
      Low: 852.19,
      Volume: "-",
    },
    {
      DATE: "2023-10-23",
      Close: 862.22,
      Open: 857.96,
      High: 873.39,
      Low: 843.34,
      Volume: "-",
    },
    {
      DATE: "2023-10-24",
      Close: 881.11,
      Open: 864,
      High: 883,
      Low: 864,
      Volume: "-",
    },
    {
      DATE: "2023-10-25",
      Close: 849.63,
      Open: 877.07,
      High: 878.41,
      Low: 846.18,
      Volume: "-",
    },
    {
      DATE: "2023-10-26",
      Close: 826.75,
      Open: 847.48,
      High: 853.8,
      Low: 818.81,
      Volume: "-",
    },
    {
      DATE: "2023-10-27",
      Close: 838.36,
      Open: 830,
      High: 840,
      Low: 828.96,
      Volume: "-",
    },
    {
      DATE: "2023-10-30",
      Close: 841.25,
      Open: 841.1,
      High: 849.23,
      Low: 827.42,
      Volume: "-",
    },
    {
      DATE: "2023-10-31",
      Close: 841.37,
      Open: 843.89,
      High: 845,
      Low: 832.6,
      Volume: "-",
    },
    {
      DATE: "2023-11-01",
      Close: 852.94,
      Open: 842,
      High: 853.68,
      Low: 835.89,
      Volume: "-",
    },
    {
      DATE: "2023-11-02",
      Close: 871.3,
      Open: 862,
      High: 880.35,
      Low: 860,
      Volume: "-",
    },
    {
      DATE: "2023-11-03",
      Close: 882.68,
      Open: 877.5,
      High: 887.39,
      Low: 871.7,
      Volume: "-",
    },
    {
      DATE: "2023-11-06",
      Close: 880.83,
      Open: 881.56,
      High: 885.85,
      Low: 871.62,
      Volume: "-",
    },
    {
      DATE: "2023-11-07",
      Close: 897.82,
      Open: 882.32,
      High: 901.73,
      Low: 876.32,
      Volume: "-",
    },
    {
      DATE: "2023-11-08",
      Close: 911.13,
      Open: 900,
      High: 912.74,
      Low: 899.52,
      Volume: "-",
    },
    {
      DATE: "2023-11-09",
      Close: 911.38,
      Open: 912.5,
      High: 929.4,
      Low: 909,
      Volume: "-",
    },
    {
      DATE: "2023-11-10",
      Close: 957.52,
      Open: 921.74,
      High: 958.56,
      Low: 919.58,
      Volume: "-",
    },
    {
      DATE: "2023-11-13",
      Close: 946.93,
      Open: 950.05,
      High: 952.4,
      Low: 940.62,
      Volume: "-",
    },
    {
      DATE: "2023-11-14",
      Close: 972.96,
      Open: 960,
      High: 976.72,
      Low: 955.96,
      Volume: "-",
    },
    {
      DATE: "2023-11-15",
      Close: 975.4,
      Open: 979.51,
      High: 981,
      Low: 966.91,
      Volume: "-",
    },
    {
      DATE: "2023-11-16",
      Close: 959.55,
      Open: 964,
      High: 968.7,
      Low: 950.53,
      Volume: "-",
    },
    {
      DATE: "2023-11-17",
      Close: 977.73,
      Open: 958.21,
      High: 983.69,
      Low: 951,
      Volume: "-",
    },
    {
      DATE: "2023-11-20",
      Close: 995.71,
      Open: 973,
      High: 999.76,
      Low: 973,
      Volume: "-",
    },
    {
      DATE: "2023-11-21",
      Close: 981.2,
      Open: 975,
      High: 991,
      Low: 972.54,
      Volume: "-",
    },
    {
      DATE: "2023-11-22",
      Close: 972,
      Open: 983.69,
      High: 987.89,
      Low: 971,
      Volume: "-",
    },
    {
      DATE: "2023-11-24",
      Close: 978.87,
      Open: 974.96,
      High: 979.48,
      Low: 966.77,
      Volume: "-",
    },
    {
      DATE: "2023-11-27",
      Close: 950.24,
      Open: 976.15,
      High: 981.01,
      Low: 949.62,
      Volume: "-",
    },
    {
      DATE: "2023-11-28",
      Close: 946.35,
      Open: 939.94,
      High: 950.85,
      Low: 934.22,
      Volume: "-",
    },
    {
      DATE: "2023-11-29",
      Close: 940.83,
      Open: 948.34,
      High: 959.26,
      Low: 939.37,
      Volume: "-",
    },
    {
      DATE: "2023-11-30",
      Close: 925.73,
      Open: 941,
      High: 941,
      Low: 918.44,
      Volume: "-",
    },
    {
      DATE: "2023-12-01",
      Close: 930,
      Open: 922.46,
      High: 933.87,
      Low: 908.01,
      Volume: "-",
    },
    {
      DATE: "2023-12-04",
      Close: 923.97,
      Open: 920.64,
      High: 930.795,
      Low: 916.44,
      Volume: "-",
    },
    {
      DATE: "2023-12-05",
      Close: 913.12,
      Open: 911.6,
      High: 917.25,
      Low: 906,
      Volume: "-",
    },
    {
      DATE: "2023-12-06",
      Close: 903.64,
      Open: 920.36,
      High: 920.36,
      Low: 903.11,
      Volume: "-",
    },
    {
      DATE: "2023-12-07",
      Close: 922.26,
      Open: 905.54,
      High: 924.08,
      Low: 904.3,
      Volume: "-",
    },
    {
      DATE: "2023-12-08",
      Close: 944.3,
      Open: 927.84,
      High: 950.65,
      Low: 910.57,
      Volume: "-",
    },
    {
      DATE: "2023-12-11",
      Close: 1029.24,
      Open: 957.01,
      High: 1039.44,
      Low: 956.43,
      Volume: "-",
    },
  ],
};
export const charData3 = {
  name: "brent oil",
  desc: "EOD Quote",
  table: {
    DATE: "2023-12-11",
    Open: 75.73,
    "Day High": 76.5,
    "Day Low": 75.01,
    "Prev Close": 75.65,
    "%CHG": "0.61",
  },
  dataList: [
    {
      DATE: "2022-12-13",
      Close: 80.39,
      Open: 78.13,
      High: 81.28,
      Low: 78.1,
      Volume: "-",
    },
    {
      DATE: "2022-12-14",
      Close: 82.8,
      Open: 80.35,
      High: 83.15,
      Low: 80.11,
      Volume: "-",
    },
    {
      DATE: "2022-12-15",
      Close: 81.45,
      Open: 82.76,
      High: 83.18,
      Low: 80.83,
      Volume: "-",
    },
    {
      DATE: "2022-12-16",
      Close: 79.26,
      Open: 81.32,
      High: 81.78,
      Low: 78.29,
      Volume: "-",
    },
    {
      DATE: "2022-12-19",
      Close: 80.1,
      Open: 79.21,
      High: 80.87,
      Low: 78.6,
      Volume: "-",
    },
    {
      DATE: "2022-12-20",
      Close: 79.68,
      Open: 80.25,
      High: 80.89,
      Low: 78.28,
      Volume: "-",
    },
    {
      DATE: "2022-12-21",
      Close: 82.28,
      Open: 79.94,
      High: 82.52,
      Low: 79.55,
      Volume: "-",
    },
    {
      DATE: "2022-12-22",
      Close: 81.69,
      Open: 82.52,
      High: 83.85,
      Low: 80.67,
      Volume: "-",
    },
    {
      DATE: "2022-12-23",
      Close: 83.97,
      Open: 81.69,
      High: 84.12,
      Low: 81.29,
      Volume: "-",
    },
    {
      DATE: "2022-12-27",
      Close: 84.83,
      Open: 84.5,
      High: 85.6,
      Low: 83.65,
      Volume: "-",
    },
    {
      DATE: "2022-12-28",
      Close: 83.11,
      Open: 84.6,
      High: 84.76,
      Low: 81.92,
      Volume: "-",
    },
    {
      DATE: "2022-12-29",
      Close: 82.27,
      Open: 82.88,
      High: 83.14,
      Low: 81.28,
      Volume: "-",
    },
    {
      DATE: "2022-12-30",
      Close: 85.99,
      Open: 83.71,
      High: 86,
      Low: 82.88,
      Volume: "-",
    },
    {
      DATE: "2023-01-03",
      Close: 82.46,
      Open: 85.96,
      High: 87,
      Low: 81.78,
      Volume: "-",
    },
    {
      DATE: "2023-01-04",
      Close: 78.1,
      Open: 82.31,
      High: 82.72,
      Low: 77.72,
      Volume: "-",
    },
    {
      DATE: "2023-01-05",
      Close: 78.88,
      Open: 78.16,
      High: 79.97,
      Low: 77.61,
      Volume: "-",
    },
    {
      DATE: "2023-01-06",
      Close: 78.6,
      Open: 78.8,
      High: 80.59,
      Low: 78.05,
      Volume: "-",
    },
    {
      DATE: "2023-01-09",
      Close: 79.8,
      Open: 78.42,
      High: 81.37,
      Low: 78.42,
      Volume: "-",
    },
    {
      DATE: "2023-01-10",
      Close: 79.62,
      Open: 79.54,
      High: 80.89,
      Low: 78.81,
      Volume: "-",
    },
    {
      DATE: "2023-01-11",
      Close: 82.91,
      Open: 79.52,
      High: 83,
      Low: 79.31,
      Volume: "-",
    },
    {
      DATE: "2023-01-12",
      Close: 83.82,
      Open: 82.88,
      High: 84.62,
      Low: 82.37,
      Volume: "-",
    },
    {
      DATE: "2023-01-13",
      Close: 85.43,
      Open: 83.91,
      High: 85.5,
      Low: 83.5,
      Volume: "-",
    },
    {
      DATE: "2023-01-16",
      Close: 84.12,
      Open: 85.36,
      High: 85.59,
      Low: 83.83,
      Volume: "-",
    },
    {
      DATE: "2023-01-17",
      Close: 86.7,
      Open: 84.2,
      High: 86.82,
      Low: 84.04,
      Volume: "-",
    },
    {
      DATE: "2023-01-18",
      Close: 84.64,
      Open: 86.45,
      High: 87.85,
      Low: 84.36,
      Volume: "-",
    },
    {
      DATE: "2023-01-19",
      Close: 86.38,
      Open: 84.34,
      High: 86.85,
      Low: 83.76,
      Volume: "-",
    },
    {
      DATE: "2023-01-20",
      Close: 87.66,
      Open: 86.42,
      High: 87.79,
      Low: 85.58,
      Volume: "-",
    },
    {
      DATE: "2023-01-23",
      Close: 88.15,
      Open: 87.7,
      High: 89.09,
      Low: 86.92,
      Volume: "-",
    },
    {
      DATE: "2023-01-24",
      Close: 86.42,
      Open: 88.07,
      High: 88.71,
      Low: 85.8,
      Volume: "-",
    },
    {
      DATE: "2023-01-25",
      Close: 86.18,
      Open: 86.28,
      High: 87,
      Low: 85.41,
      Volume: "-",
    },
    {
      DATE: "2023-01-26",
      Close: 87.72,
      Open: 86.35,
      High: 88.01,
      Low: 85.74,
      Volume: "-",
    },
    {
      DATE: "2023-01-27",
      Close: 86.33,
      Open: 87.65,
      High: 88.95,
      Low: 85.69,
      Volume: "-",
    },
    {
      DATE: "2023-01-30",
      Close: 85.59,
      Open: 86.88,
      High: 87.48,
      Low: 84.66,
      Volume: "-",
    },
    {
      DATE: "2023-01-31",
      Close: 84.47,
      Open: 85.18,
      High: 85.25,
      Low: 83.73,
      Volume: "-",
    },
    {
      DATE: "2023-02-01",
      Close: 83.06,
      Open: 85.56,
      High: 86.21,
      Low: 82.37,
      Volume: "-",
    },
    {
      DATE: "2023-02-02",
      Close: 82.1,
      Open: 83.34,
      High: 83.61,
      Low: 81.25,
      Volume: "-",
    },
    {
      DATE: "2023-02-03",
      Close: 79.82,
      Open: 82.27,
      High: 84.2,
      Low: 79.62,
      Volume: "-",
    },
    {
      DATE: "2023-02-06",
      Close: 81.4,
      Open: 79.61,
      High: 81.43,
      Low: 79.1,
      Volume: "-",
    },
    {
      DATE: "2023-02-07",
      Close: 84.09,
      Open: 81.26,
      High: 84.13,
      Low: 81.19,
      Volume: "-",
    },
    {
      DATE: "2023-02-08",
      Close: 85.02,
      Open: 84.11,
      High: 85.15,
      Low: 83.51,
      Volume: "-",
    },
    {
      DATE: "2023-02-09",
      Close: 84.08,
      Open: 84.96,
      High: 85.5,
      Low: 83.05,
      Volume: "-",
    },
    {
      DATE: "2023-02-10",
      Close: 86.52,
      Open: 84.22,
      High: 86.9,
      Low: 83.93,
      Volume: "-",
    },
    {
      DATE: "2023-02-13",
      Close: 85.78,
      Open: 86.51,
      High: 86.95,
      Low: 85.1,
      Volume: "-",
    },
    {
      DATE: "2023-02-14",
      Close: 85.25,
      Open: 85.83,
      High: 86.42,
      Low: 84.13,
      Volume: "-",
    },
    {
      DATE: "2023-02-15",
      Close: 85.28,
      Open: 85.2,
      High: 85.85,
      Low: 83.88,
      Volume: "-",
    },
    {
      DATE: "2023-02-16",
      Close: 84.82,
      Open: 85.27,
      High: 86.21,
      Low: 84.6,
      Volume: "-",
    },
    {
      DATE: "2023-02-17",
      Close: 83.15,
      Open: 84.6,
      High: 84.87,
      Low: 81.8,
      Volume: "-",
    },
    {
      DATE: "2023-02-20",
      Close: 83.81,
      Open: 83.15,
      High: 84.3,
      Low: 82.73,
      Volume: "-",
    },
    {
      DATE: "2023-02-21",
      Close: 82.73,
      Open: 83.86,
      High: 84.2,
      Low: 82.56,
      Volume: "-",
    },
    {
      DATE: "2023-02-22",
      Close: 80.47,
      Open: 82.78,
      High: 83.25,
      Low: 80.43,
      Volume: "-",
    },
    {
      DATE: "2023-02-23",
      Close: 82.43,
      Open: 80.48,
      High: 82.77,
      Low: 80.4,
      Volume: "-",
    },
    {
      DATE: "2023-02-24",
      Close: 83.23,
      Open: 82.49,
      High: 83.39,
      Low: 81.07,
      Volume: "-",
    },
    {
      DATE: "2023-02-27",
      Close: 82.44,
      Open: 83.19,
      High: 83.6,
      Low: 81.73,
      Volume: "-",
    },
    {
      DATE: "2023-02-28",
      Close: 83.87,
      Open: 82.3,
      High: 84.15,
      Low: 82.19,
      Volume: "-",
    },
    {
      DATE: "2023-03-01",
      Close: 84.43,
      Open: 83.05,
      High: 84.49,
      Low: 82.61,
      Volume: "-",
    },
    {
      DATE: "2023-03-02",
      Close: 84.35,
      Open: 84.31,
      High: 85.1,
      Low: 83.83,
      Volume: "-",
    },
    {
      DATE: "2023-03-03",
      Close: 86,
      Open: 84.61,
      High: 86,
      Low: 82.36,
      Volume: "-",
    },
    {
      DATE: "2023-03-06",
      Close: 86.25,
      Open: 85.83,
      High: 86.35,
      Low: 84.34,
      Volume: "-",
    },
    {
      DATE: "2023-03-07",
      Close: 83.08,
      Open: 86.23,
      High: 86.75,
      Low: 82.83,
      Volume: "-",
    },
    {
      DATE: "2023-03-08",
      Close: 82.52,
      Open: 83.03,
      High: 83.59,
      Low: 82.06,
      Volume: "-",
    },
    {
      DATE: "2023-03-09",
      Close: 81.56,
      Open: 82.55,
      High: 84,
      Low: 81.42,
      Volume: "-",
    },
    {
      DATE: "2023-03-10",
      Close: 82.64,
      Open: 81.47,
      High: 83.11,
      Low: 80.73,
      Volume: "-",
    },
    {
      DATE: "2023-03-13",
      Close: 80.74,
      Open: 82.6,
      High: 83.48,
      Low: 78.34,
      Volume: "-",
    },
    {
      DATE: "2023-03-14",
      Close: 77.61,
      Open: 80.54,
      High: 80.92,
      Low: 76.89,
      Volume: "-",
    },
    {
      DATE: "2023-03-15",
      Close: 74.27,
      Open: 77.82,
      High: 78.73,
      Low: 71.67,
      Volume: "-",
    },
    {
      DATE: "2023-03-16",
      Close: 74.71,
      Open: 74.3,
      High: 75.54,
      Low: 71.86,
      Volume: "-",
    },
    {
      DATE: "2023-03-17",
      Close: 72.47,
      Open: 74.7,
      High: 75.92,
      Low: 71.4,
      Volume: "-",
    },
    {
      DATE: "2023-03-20",
      Close: 73.77,
      Open: 73.01,
      High: 73.87,
      Low: 70.12,
      Volume: "-",
    },
    {
      DATE: "2023-03-21",
      Close: 75.07,
      Open: 73.64,
      High: 75.42,
      Low: 72.82,
      Volume: "-",
    },
    {
      DATE: "2023-03-22",
      Close: 75.79,
      Open: 75.15,
      High: 77.12,
      Low: 74.5,
      Volume: "-",
    },
    {
      DATE: "2023-03-23",
      Close: 75.59,
      Open: 75.87,
      High: 77.44,
      Low: 75.12,
      Volume: "-",
    },
    {
      DATE: "2023-03-24",
      Close: 75,
      Open: 75.53,
      High: 76.32,
      Low: 72.68,
      Volume: "-",
    },
    {
      DATE: "2023-03-27",
      Close: 78.15,
      Open: 75,
      High: 78.42,
      Low: 74.8,
      Volume: "-",
    },
    {
      DATE: "2023-03-28",
      Close: 78.91,
      Open: 78.23,
      High: 79.2,
      Low: 77.54,
      Volume: "-",
    },
    {
      DATE: "2023-03-29",
      Close: 78.28,
      Open: 78.97,
      High: 79.68,
      Low: 77.94,
      Volume: "-",
    },
    {
      DATE: "2023-03-30",
      Close: 79.22,
      Open: 78.23,
      High: 79.55,
      Low: 77.86,
      Volume: "-",
    },
    {
      DATE: "2023-03-31",
      Close: 79.74,
      Open: 79.19,
      High: 79.8,
      Low: 78.54,
      Volume: "-",
    },
    {
      DATE: "2023-04-03",
      Close: 84.78,
      Open: 86,
      High: 86.44,
      Low: 83.5,
      Volume: "-",
    },
    {
      DATE: "2023-04-04",
      Close: 85.26,
      Open: 84.89,
      High: 86.04,
      Low: 83.82,
      Volume: "-",
    },
    {
      DATE: "2023-04-05",
      Close: 84.88,
      Open: 85.22,
      High: 85.54,
      Low: 84.01,
      Volume: "-",
    },
    {
      DATE: "2023-04-06",
      Close: 84.94,
      Open: 84.89,
      High: 85.45,
      Low: 84.05,
      Volume: "-",
    },
    {
      DATE: "2023-04-10",
      Close: 84.31,
      Open: 85.1,
      High: 85.66,
      Low: 84.09,
      Volume: "-",
    },
    {
      DATE: "2023-04-11",
      Close: 85.62,
      Open: 84.24,
      High: 85.67,
      Low: 83.75,
      Volume: "-",
    },
    {
      DATE: "2023-04-12",
      Close: 87.23,
      Open: 85.59,
      High: 87.49,
      Low: 85.39,
      Volume: "-",
    },
    {
      DATE: "2023-04-13",
      Close: 86.31,
      Open: 87.19,
      High: 87.47,
      Low: 86.05,
      Volume: "-",
    },
    {
      DATE: "2023-04-14",
      Close: 86.63,
      Open: 86.18,
      High: 86.87,
      Low: 85.53,
      Volume: "-",
    },
    {
      DATE: "2023-04-17",
      Close: 84.83,
      Open: 86.43,
      High: 86.52,
      Low: 84.34,
      Volume: "-",
    },
    {
      DATE: "2023-04-18",
      Close: 84.87,
      Open: 84.74,
      High: 85.41,
      Low: 83.81,
      Volume: "-",
    },
    {
      DATE: "2023-04-19",
      Close: 82.88,
      Open: 84.9,
      High: 85.15,
      Low: 82.39,
      Volume: "-",
    },
    {
      DATE: "2023-04-20",
      Close: 80.86,
      Open: 82.75,
      High: 82.92,
      Low: 80.77,
      Volume: "-",
    },
    {
      DATE: "2023-04-21",
      Close: 81.75,
      Open: 80.79,
      High: 82.05,
      Low: 80.45,
      Volume: "-",
    },
    {
      DATE: "2023-04-24",
      Close: 82.54,
      Open: 81.87,
      High: 82.99,
      Low: 80.48,
      Volume: "-",
    },
    {
      DATE: "2023-04-25",
      Close: 80.76,
      Open: 82.59,
      High: 83.06,
      Low: 80.35,
      Volume: "-",
    },
    {
      DATE: "2023-04-26",
      Close: 77.77,
      Open: 80.92,
      High: 81.47,
      Low: 77.46,
      Volume: "-",
    },
    {
      DATE: "2023-04-27",
      Close: 78.28,
      Open: 77.77,
      High: 78.61,
      Low: 77.39,
      Volume: "-",
    },
    {
      DATE: "2023-04-28",
      Close: 79.51,
      Open: 78.25,
      High: 79.61,
      Low: 77.69,
      Volume: "-",
    },
    {
      DATE: "2023-05-01",
      Close: 79.4,
      Open: 80.11,
      High: 80.24,
      Low: 78.13,
      Volume: "-",
    },
    {
      DATE: "2023-05-02",
      Close: 75.23,
      Open: 79.28,
      High: 79.78,
      Low: 75.07,
      Volume: "-",
    },
    {
      DATE: "2023-05-03",
      Close: 71.93,
      Open: 75.31,
      High: 75.58,
      Low: 71.7,
      Volume: "-",
    },
    {
      DATE: "2023-05-04",
      Close: 72.54,
      Open: 71.28,
      High: 73.72,
      Low: 71.28,
      Volume: "-",
    },
    {
      DATE: "2023-05-05",
      Close: 75.37,
      Open: 72.69,
      High: 75.75,
      Low: 72.41,
      Volume: "-",
    },
    {
      DATE: "2023-05-08",
      Close: 76.61,
      Open: 75.23,
      High: 77.43,
      Low: 74.95,
      Volume: "-",
    },
    {
      DATE: "2023-05-09",
      Close: 77.28,
      Open: 76.71,
      High: 77.5,
      Low: 75.07,
      Volume: "-",
    },
    {
      DATE: "2023-05-10",
      Close: 76.59,
      Open: 77.36,
      High: 77.6,
      Low: 75.68,
      Volume: "-",
    },
    {
      DATE: "2023-05-11",
      Close: 75.43,
      Open: 76.62,
      High: 77.41,
      Low: 74.61,
      Volume: "-",
    },
    {
      DATE: "2023-05-12",
      Close: 74.17,
      Open: 75.35,
      High: 75.85,
      Low: 74.03,
      Volume: "-",
    },
    {
      DATE: "2023-05-15",
      Close: 75.56,
      Open: 74.15,
      High: 75.75,
      Low: 73.49,
      Volume: "-",
    },
    {
      DATE: "2023-05-16",
      Close: 74.75,
      Open: 75.55,
      High: 75.95,
      Low: 74.5,
      Volume: "-",
    },
    {
      DATE: "2023-05-17",
      Close: 76.78,
      Open: 74.67,
      High: 77.31,
      Low: 74.1,
      Volume: "-",
    },
    {
      DATE: "2023-05-18",
      Close: 75.95,
      Open: 76.78,
      High: 76.99,
      Low: 75.5,
      Volume: "-",
    },
    {
      DATE: "2023-05-19",
      Close: 75.59,
      Open: 76.03,
      High: 77.5,
      Low: 75.12,
      Volume: "-",
    },
    {
      DATE: "2023-05-22",
      Close: 75.94,
      Open: 75.63,
      High: 76.46,
      Low: 74.55,
      Volume: "-",
    },
    {
      DATE: "2023-05-23",
      Close: 77.5,
      Open: 76.15,
      High: 77.74,
      Low: 75.65,
      Volume: "-",
    },
    {
      DATE: "2023-05-24",
      Close: 78.34,
      Open: 77.7,
      High: 78.66,
      Low: 77.03,
      Volume: "-",
    },
    {
      DATE: "2023-05-25",
      Close: 76.23,
      Open: 78.22,
      High: 78.5,
      Low: 75.1,
      Volume: "-",
    },
    {
      DATE: "2023-05-26",
      Close: 77.12,
      Open: 76.09,
      High: 77.35,
      Low: 75.73,
      Volume: "-",
    },
    {
      DATE: "2023-05-29",
      Close: 77.03,
      Open: 77.39,
      High: 77.75,
      Low: 76.15,
      Volume: "-",
    },
    {
      DATE: "2023-05-30",
      Close: 73.69,
      Open: 76.98,
      High: 77.57,
      Low: 73.2,
      Volume: "-",
    },
    {
      DATE: "2023-05-31",
      Close: 72.71,
      Open: 73.6,
      High: 73.81,
      Low: 71.39,
      Volume: "-",
    },
    {
      DATE: "2023-06-01",
      Close: 74.32,
      Open: 72.15,
      High: 75.25,
      Low: 72.03,
      Volume: "-",
    },
    {
      DATE: "2023-06-02",
      Close: 76.4,
      Open: 74.28,
      High: 76.5,
      Low: 74.18,
      Volume: "-",
    },
    {
      DATE: "2023-06-05",
      Close: 76.6,
      Open: 77.68,
      High: 78.73,
      Low: 76.31,
      Volume: "-",
    },
    {
      DATE: "2023-06-06",
      Close: 76.12,
      Open: 76.55,
      High: 76.75,
      Low: 74.72,
      Volume: "-",
    },
    {
      DATE: "2023-06-07",
      Close: 76.8,
      Open: 76.22,
      High: 77.64,
      Low: 75.51,
      Volume: "-",
    },
    {
      DATE: "2023-06-08",
      Close: 75.52,
      Open: 76.8,
      High: 77.68,
      Low: 73.58,
      Volume: "-",
    },
    {
      DATE: "2023-06-09",
      Close: 75.04,
      Open: 75.53,
      High: 76.57,
      Low: 74.71,
      Volume: "-",
    },
    {
      DATE: "2023-06-12",
      Close: 72.11,
      Open: 74.87,
      High: 74.87,
      Low: 71.58,
      Volume: "-",
    },
    {
      DATE: "2023-06-13",
      Close: 74.19,
      Open: 72.11,
      High: 74.66,
      Low: 71.94,
      Volume: "-",
    },
    {
      DATE: "2023-06-14",
      Close: 73.61,
      Open: 74.05,
      High: 75.49,
      Low: 73.03,
      Volume: "-",
    },
    {
      DATE: "2023-06-15",
      Close: 75.63,
      Open: 73.41,
      High: 75.97,
      Low: 72.91,
      Volume: "-",
    },
    {
      DATE: "2023-06-16",
      Close: 76.26,
      Open: 75.64,
      High: 76.74,
      Low: 75.08,
      Volume: "-",
    },
    {
      DATE: "2023-06-19",
      Close: 76.13,
      Open: 76.4,
      High: 76.93,
      Low: 75.34,
      Volume: "-",
    },
    {
      DATE: "2023-06-20",
      Close: 75.42,
      Open: 76.12,
      High: 77.15,
      Low: 74.51,
      Volume: "-",
    },
    {
      DATE: "2023-06-21",
      Close: 77.03,
      Open: 75.54,
      High: 77.24,
      Low: 75.52,
      Volume: "-",
    },
    {
      DATE: "2023-06-22",
      Close: 74.23,
      Open: 77.03,
      High: 77.2,
      Low: 73.59,
      Volume: "-",
    },
    {
      DATE: "2023-06-23",
      Close: 74.44,
      Open: 74.02,
      High: 74.44,
      Low: 72.11,
      Volume: "-",
    },
    {
      DATE: "2023-06-26",
      Close: 74.39,
      Open: 74.5,
      High: 74.85,
      Low: 73.42,
      Volume: "-",
    },
    {
      DATE: "2023-06-27",
      Close: 72.69,
      Open: 74.28,
      High: 74.9,
      Low: 72.08,
      Volume: "-",
    },
    {
      DATE: "2023-06-28",
      Close: 73.57,
      Open: 72.62,
      High: 74.2,
      Low: 71.57,
      Volume: "-",
    },
    {
      DATE: "2023-06-29",
      Close: 74.31,
      Open: 73.72,
      High: 74.98,
      Low: 73.39,
      Volume: "-",
    },
    {
      DATE: "2023-06-30",
      Close: 74.91,
      Open: 74.22,
      High: 75.4,
      Low: 74.21,
      Volume: "-",
    },
    {
      DATE: "2023-07-03",
      Close: 74.96,
      Open: 75.11,
      High: 76.6,
      Low: 74.56,
      Volume: "-",
    },
    {
      DATE: "2023-07-04",
      Close: 76.12,
      Open: 74.89,
      High: 76.29,
      Low: 74.74,
      Volume: "-",
    },
    {
      DATE: "2023-07-05",
      Close: 76.53,
      Open: 76.03,
      High: 76.95,
      Low: 75.3,
      Volume: "-",
    },
    {
      DATE: "2023-07-06",
      Close: 76.51,
      Open: 76.7,
      High: 77.09,
      Low: 75.03,
      Volume: "-",
    },
    {
      DATE: "2023-07-07",
      Close: 78.17,
      Open: 76.52,
      High: 78.54,
      Low: 76.03,
      Volume: "-",
    },
    {
      DATE: "2023-07-10",
      Close: 77.79,
      Open: 78.6,
      High: 78.77,
      Low: 77.36,
      Volume: "-",
    },
    {
      DATE: "2023-07-11",
      Close: 79.35,
      Open: 77.82,
      High: 79.5,
      Low: 77.63,
      Volume: "-",
    },
    {
      DATE: "2023-07-12",
      Close: 80.2,
      Open: 79.32,
      High: 80.55,
      Low: 79.21,
      Volume: "-",
    },
    {
      DATE: "2023-07-13",
      Close: 81.54,
      Open: 80.19,
      High: 81.75,
      Low: 79.88,
      Volume: "-",
    },
    {
      DATE: "2023-07-14",
      Close: 79.63,
      Open: 81.64,
      High: 81.7,
      Low: 79.53,
      Volume: "-",
    },
    {
      DATE: "2023-07-17",
      Close: 78.56,
      Open: 79.36,
      High: 80.64,
      Low: 78.25,
      Volume: "-",
    },
    {
      DATE: "2023-07-18",
      Close: 79.82,
      Open: 78.52,
      High: 79.99,
      Low: 78.19,
      Volume: "-",
    },
    {
      DATE: "2023-07-19",
      Close: 79.54,
      Open: 79.84,
      High: 80.93,
      Low: 79.17,
      Volume: "-",
    },
    {
      DATE: "2023-07-20",
      Close: 79.62,
      Open: 79.33,
      High: 80.27,
      Low: 78.66,
      Volume: "-",
    },
    {
      DATE: "2023-07-21",
      Close: 80.89,
      Open: 79.78,
      High: 81.24,
      Low: 79.65,
      Volume: "-",
    },
    {
      DATE: "2023-07-24",
      Close: 82.75,
      Open: 80.95,
      High: 83.16,
      Low: 80.42,
      Volume: "-",
    },
    {
      DATE: "2023-07-25",
      Close: 83.2,
      Open: 82.85,
      High: 83.87,
      Low: 82.22,
      Volume: "-",
    },
    {
      DATE: "2023-07-26",
      Close: 82.95,
      Open: 83.19,
      High: 83.85,
      Low: 82.58,
      Volume: "-",
    },
    {
      DATE: "2023-07-27",
      Close: 83.86,
      Open: 82.93,
      High: 84.5,
      Low: 82.93,
      Volume: "-",
    },
    {
      DATE: "2023-07-28",
      Close: 84.75,
      Open: 83.71,
      High: 85.09,
      Low: 83.22,
      Volume: "-",
    },
    {
      DATE: "2023-07-31",
      Close: 85.56,
      Open: 84.95,
      High: 85.8,
      Low: 84.4,
      Volume: "-",
    },
    {
      DATE: "2023-08-01",
      Close: 85.68,
      Open: 85.24,
      High: 85.91,
      Low: 84.21,
      Volume: "-",
    },
    {
      DATE: "2023-08-02",
      Close: 83.38,
      Open: 85.86,
      High: 85.99,
      Low: 82.74,
      Volume: "-",
    },
    {
      DATE: "2023-08-03",
      Close: 85.25,
      Open: 83.46,
      High: 85.41,
      Low: 82.36,
      Volume: "-",
    },
    {
      DATE: "2023-08-04",
      Close: 86.15,
      Open: 85.31,
      High: 86.65,
      Low: 85.06,
      Volume: "-",
    },
    {
      DATE: "2023-08-07",
      Close: 85.91,
      Open: 86.23,
      High: 86.73,
      Low: 85.03,
      Volume: "-",
    },
    {
      DATE: "2023-08-08",
      Close: 86.18,
      Open: 85.79,
      High: 86.34,
      Low: 83.32,
      Volume: "-",
    },
    {
      DATE: "2023-08-09",
      Close: 87.51,
      Open: 86,
      High: 87.65,
      Low: 85.91,
      Volume: "-",
    },
    {
      DATE: "2023-08-10",
      Close: 86.33,
      Open: 87.39,
      High: 88.1,
      Low: 86.2,
      Volume: "-",
    },
    {
      DATE: "2023-08-11",
      Close: 86.73,
      Open: 86.37,
      High: 87.35,
      Low: 85.84,
      Volume: "-",
    },
    {
      DATE: "2023-08-14",
      Close: 86.23,
      Open: 86.53,
      High: 86.71,
      Low: 85.5,
      Volume: "-",
    },
    {
      DATE: "2023-08-15",
      Close: 85.08,
      Open: 86.12,
      High: 86.68,
      Low: 84.29,
      Volume: "-",
    },
    {
      DATE: "2023-08-16",
      Close: 83.37,
      Open: 85.2,
      High: 85.36,
      Low: 83.13,
      Volume: "-",
    },
    {
      DATE: "2023-08-17",
      Close: 83.9,
      Open: 83.2,
      High: 84.88,
      Low: 83.05,
      Volume: "-",
    },
    {
      DATE: "2023-08-18",
      Close: 84.83,
      Open: 83.88,
      High: 85.08,
      Low: 83.33,
      Volume: "-",
    },
    {
      DATE: "2023-08-21",
      Close: 84.59,
      Open: 84.8,
      High: 85.86,
      Low: 84.31,
      Volume: "-",
    },
    {
      DATE: "2023-08-22",
      Close: 83.89,
      Open: 84.46,
      High: 84.66,
      Low: 83.85,
      Volume: "-",
    },
    {
      DATE: "2023-08-23",
      Close: 83.07,
      Open: 83.99,
      High: 84.26,
      Low: 81.94,
      Volume: "-",
    },
    {
      DATE: "2023-08-24",
      Close: 83.23,
      Open: 82.95,
      High: 83.62,
      Low: 81.97,
      Volume: "-",
    },
    {
      DATE: "2023-08-25",
      Close: 84.85,
      Open: 83.26,
      High: 84.97,
      Low: 82.67,
      Volume: "-",
    },
    {
      DATE: "2023-08-28",
      Close: 84.42,
      Open: 84.87,
      High: 85.23,
      Low: 84.11,
      Volume: "-",
    },
    {
      DATE: "2023-08-29",
      Close: 85.53,
      Open: 84.39,
      High: 85.65,
      Low: 83.8,
      Volume: "-",
    },
    {
      DATE: "2023-08-30",
      Close: 85.97,
      Open: 85.62,
      High: 86.23,
      Low: 85.11,
      Volume: "-",
    },
    {
      DATE: "2023-08-31",
      Close: 86.83,
      Open: 86,
      High: 86.94,
      Low: 85.74,
      Volume: "-",
    },
    {
      DATE: "2023-09-01",
      Close: 88.99,
      Open: 86.82,
      High: 88.99,
      Low: 86.74,
      Volume: "-",
    },
    {
      DATE: "2023-09-04",
      Close: 89,
      Open: 88.95,
      High: 89.22,
      Low: 88.26,
      Volume: "-",
    },
    {
      DATE: "2023-09-05",
      Close: 90.05,
      Open: 88.91,
      High: 91.15,
      Low: 88.06,
      Volume: "-",
    },
    {
      DATE: "2023-09-06",
      Close: 90.63,
      Open: 90.12,
      High: 91.1,
      Low: 89.25,
      Volume: "-",
    },
    {
      DATE: "2023-09-07",
      Close: 89.76,
      Open: 90.81,
      High: 90.89,
      Low: 89.46,
      Volume: "-",
    },
    {
      DATE: "2023-09-08",
      Close: 90.44,
      Open: 89.79,
      High: 91.02,
      Low: 89.3,
      Volume: "-",
    },
    {
      DATE: "2023-09-11",
      Close: 90.61,
      Open: 90.83,
      High: 91.45,
      Low: 90.11,
      Volume: "-",
    },
    {
      DATE: "2023-09-12",
      Close: 91.96,
      Open: 90.62,
      High: 92.4,
      Low: 90.52,
      Volume: "-",
    },
    {
      DATE: "2023-09-13",
      Close: 92.19,
      Open: 92.04,
      High: 92.84,
      Low: 91.63,
      Volume: "-",
    },
    {
      DATE: "2023-09-14",
      Close: 94.14,
      Open: 92.04,
      High: 94.21,
      Low: 92.02,
      Volume: "-",
    },
    {
      DATE: "2023-09-15",
      Close: 94.27,
      Open: 94.02,
      High: 94.63,
      Low: 92.67,
      Volume: "-",
    },
    {
      DATE: "2023-09-18",
      Close: 94.57,
      Open: 94.28,
      High: 94.95,
      Low: 93.79,
      Volume: "-",
    },
    {
      DATE: "2023-09-19",
      Close: 94.4,
      Open: 94.66,
      High: 95.96,
      Low: 94.16,
      Volume: "-",
    },
    {
      DATE: "2023-09-20",
      Close: 93.2,
      Open: 94.49,
      High: 94.72,
      Low: 92.76,
      Volume: "-",
    },
    {
      DATE: "2023-09-21",
      Close: 93.24,
      Open: 93.08,
      High: 94.6,
      Low: 92.2,
      Volume: "-",
    },
    {
      DATE: "2023-09-22",
      Close: 93.83,
      Open: 93.37,
      High: 94.64,
      Low: 92.8,
      Volume: "-",
    },
    {
      DATE: "2023-09-25",
      Close: 93.41,
      Open: 93.75,
      High: 94.25,
      Low: 92.54,
      Volume: "-",
    },
    {
      DATE: "2023-09-26",
      Close: 94.07,
      Open: 93.28,
      High: 94.21,
      Low: 91.8,
      Volume: "-",
    },
    {
      DATE: "2023-09-27",
      Close: 96.71,
      Open: 94.12,
      High: 97.06,
      Low: 94.1,
      Volume: "-",
    },
    {
      DATE: "2023-09-28",
      Close: 95.14,
      Open: 96.74,
      High: 97.69,
      Low: 94.76,
      Volume: "-",
    },
    {
      DATE: "2023-09-29",
      Close: 95.34,
      Open: 95.07,
      High: 96.26,
      Low: 94.9,
      Volume: "-",
    },
    {
      DATE: "2023-10-02",
      Close: 90.48,
      Open: 92.18,
      High: 93.33,
      Low: 90.35,
      Volume: "-",
    },
    {
      DATE: "2023-10-03",
      Close: 91.1,
      Open: 90.4,
      High: 91.56,
      Low: 89.5,
      Volume: "-",
    },
    {
      DATE: "2023-10-04",
      Close: 86.09,
      Open: 91.04,
      High: 91.21,
      Low: 85.75,
      Volume: "-",
    },
    {
      DATE: "2023-10-05",
      Close: 84.18,
      Open: 85.88,
      High: 86.52,
      Low: 83.84,
      Volume: "-",
    },
    {
      DATE: "2023-10-06",
      Close: 84.43,
      Open: 84.49,
      High: 84.95,
      Low: 83.44,
      Volume: "-",
    },
    {
      DATE: "2023-10-09",
      Close: 88.25,
      Open: 86.45,
      High: 89,
      Low: 86,
      Volume: "-",
    },
    {
      DATE: "2023-10-10",
      Close: 87.72,
      Open: 88.17,
      High: 88.49,
      Low: 86.91,
      Volume: "-",
    },
    {
      DATE: "2023-10-11",
      Close: 85.54,
      Open: 87.72,
      High: 88.26,
      Low: 85.21,
      Volume: "-",
    },
    {
      DATE: "2023-10-12",
      Close: 86.26,
      Open: 85.53,
      High: 87.64,
      Low: 85.18,
      Volume: "-",
    },
    {
      DATE: "2023-10-13",
      Close: 90.8,
      Open: 86.35,
      High: 91,
      Low: 86.28,
      Volume: "-",
    },
    {
      DATE: "2023-10-16",
      Close: 90.16,
      Open: 90.98,
      High: 91.39,
      Low: 89.5,
      Volume: "-",
    },
    {
      DATE: "2023-10-17",
      Close: 90.91,
      Open: 89.91,
      High: 91,
      Low: 88.88,
      Volume: "-",
    },
    {
      DATE: "2023-10-18",
      Close: 91.41,
      Open: 91.25,
      High: 93,
      Low: 90.6,
      Volume: "-",
    },
    {
      DATE: "2023-10-19",
      Close: 93.05,
      Open: 91.35,
      High: 93.48,
      Low: 89.57,
      Volume: "-",
    },
    {
      DATE: "2023-10-20",
      Close: 92.51,
      Open: 93.23,
      High: 93.79,
      Low: 91.66,
      Volume: "-",
    },
    {
      DATE: "2023-10-23",
      Close: 90.5,
      Open: 92.11,
      High: 92.45,
      Low: 89.62,
      Volume: "-",
    },
    {
      DATE: "2023-10-24",
      Close: 88.08,
      Open: 90.47,
      High: 90.68,
      Low: 87.35,
      Volume: "-",
    },
    {
      DATE: "2023-10-25",
      Close: 90.13,
      Open: 88.04,
      High: 90.35,
      Low: 86.68,
      Volume: "-",
    },
    {
      DATE: "2023-10-26",
      Close: 88.16,
      Open: 89.92,
      High: 90.4,
      Low: 87.53,
      Volume: "-",
    },
    {
      DATE: "2023-10-27",
      Close: 90.44,
      Open: 88.4,
      High: 90.75,
      Low: 87.83,
      Volume: "-",
    },
    {
      DATE: "2023-10-30",
      Close: 87.91,
      Open: 90.07,
      High: 90.15,
      Low: 87.2,
      Volume: "-",
    },
    {
      DATE: "2023-10-31",
      Close: 87.42,
      Open: 87.9,
      High: 88.61,
      Low: 87.4,
      Volume: "-",
    },
    {
      DATE: "2023-11-01",
      Close: 84.9,
      Open: 85.45,
      High: 87.24,
      Low: 84.58,
      Volume: "-",
    },
    {
      DATE: "2023-11-02",
      Close: 86.96,
      Open: 85,
      High: 87.05,
      Low: 84.64,
      Volume: "-",
    },
    {
      DATE: "2023-11-03",
      Close: 85.23,
      Open: 86.92,
      High: 87.8,
      Low: 84.56,
      Volume: "-",
    },
    {
      DATE: "2023-11-06",
      Close: 85.21,
      Open: 85.55,
      High: 86.46,
      Low: 84.88,
      Volume: "-",
    },
    {
      DATE: "2023-11-07",
      Close: 81.41,
      Open: 85.15,
      High: 85.19,
      Low: 81.4,
      Volume: "-",
    },
    {
      DATE: "2023-11-08",
      Close: 79.71,
      Open: 81.4,
      High: 81.96,
      Low: 79.2,
      Volume: "-",
    },
    {
      DATE: "2023-11-09",
      Close: 79.87,
      Open: 79.7,
      High: 81.48,
      Low: 79.44,
      Volume: "-",
    },
    {
      DATE: "2023-11-10",
      Close: 81.7,
      Open: 79.85,
      High: 82.06,
      Low: 79.79,
      Volume: "-",
    },
    {
      DATE: "2023-11-13",
      Close: 82.7,
      Open: 81.43,
      High: 82.84,
      Low: 80.41,
      Volume: "-",
    },
    {
      DATE: "2023-11-14",
      Close: 82.37,
      Open: 82.71,
      High: 83.97,
      Low: 82.06,
      Volume: "-",
    },
    {
      DATE: "2023-11-15",
      Close: 81.07,
      Open: 82.39,
      High: 83.04,
      Low: 80.79,
      Volume: "-",
    },
    {
      DATE: "2023-11-16",
      Close: 77.45,
      Open: 80.98,
      High: 81.17,
      Low: 76.6,
      Volume: "-",
    },
    {
      DATE: "2023-11-17",
      Close: 80.62,
      Open: 77.55,
      High: 80.81,
      Low: 77.28,
      Volume: "-",
    },
    {
      DATE: "2023-11-20",
      Close: 82.03,
      Open: 80.3,
      High: 82.94,
      Low: 79.58,
      Volume: "-",
    },
    {
      DATE: "2023-11-21",
      Close: 82.39,
      Open: 82.13,
      High: 82.54,
      Low: 81.43,
      Volume: "-",
    },
    {
      DATE: "2023-11-22",
      Close: 81.66,
      Open: 82.47,
      High: 82.65,
      Low: 78.41,
      Volume: "-",
    },
    {
      DATE: "2023-11-23",
      Close: 81.28,
      Open: 81.6,
      High: 81.63,
      Low: 80.19,
      Volume: "-",
    },
    {
      DATE: "2023-11-24",
      Close: 80.23,
      Open: 81.4,
      High: 82.2,
      Low: 80.13,
      Volume: "-",
    },
    {
      DATE: "2023-11-27",
      Close: 80.08,
      Open: 80.4,
      High: 81.17,
      Low: 79.13,
      Volume: "-",
    },
    {
      DATE: "2023-11-28",
      Close: 81.66,
      Open: 80.19,
      High: 82.16,
      Low: 79.8,
      Volume: "-",
    },
    {
      DATE: "2023-11-29",
      Close: 82.9,
      Open: 81.91,
      High: 83.25,
      Low: 80.96,
      Volume: "-",
    },
    {
      DATE: "2023-11-30",
      Close: 82.85,
      Open: 82.78,
      High: 84.75,
      Low: 82.58,
      Volume: "-",
    },
    {
      DATE: "2023-12-01",
      Close: 79.56,
      Open: 80.67,
      High: 81.54,
      Low: 78.75,
      Volume: "-",
    },
    {
      DATE: "2023-12-04",
      Close: 78.2,
      Open: 79.5,
      High: 79.72,
      Low: 77.52,
      Volume: "-",
    },
    {
      DATE: "2023-12-05",
      Close: 77,
      Open: 78.1,
      High: 79.09,
      Low: 77,
      Volume: "-",
    },
    {
      DATE: "2023-12-06",
      Close: 74.28,
      Open: 77.12,
      High: 77.65,
      Low: 74.11,
      Volume: "-",
    },
    {
      DATE: "2023-12-07",
      Close: 74.56,
      Open: 74.5,
      High: 75.48,
      Low: 73.6,
      Volume: "-",
    },
    {
      DATE: "2023-12-08",
      Close: 75.65,
      Open: 74.59,
      High: 76.36,
      Low: 74.2,
      Volume: "-",
    },
    {
      DATE: "2023-12-11",
      Close: 76.11,
      Open: 75.73,
      High: 76.5,
      Low: 75.01,
      Volume: "-",
    },
  ],
};

export const contryList = {
  BRITAIN: {
    经度: "-101.36929",
    纬度: "39.78972 ",
  },
  FRANCE: {
    经度: "1.05894",
    纬度: "47.52545",
  },
  GERMANY: {
    经度: "10.45153",
    纬度: "51.16569",
  },
  ITALY: {
    经度: "12.42220",
    纬度: "43.02243",
  },
  CANADA: {
    经度: "-106.34677",
    纬度: "56.13037",
  },
  JAPAN: {
    经度: "140.15836",
    纬度: "38.07746",
  },
  CHINA: {
    经度: "104.05650",
    纬度: "30.60781",
  },
  INDIA: {
    经度: "78.96288",
    纬度: "20.59368",
  },
  MEXICO: {
    经度: "-104.17650",
    纬度: "26.10325",
  },
  BRAZIL: {
    经度: "-53.93557",
    纬度: "-8.82311",
  },
  "SOUTH AFRICA": {
    经度: "24.25696",
    纬度: "-30.91473",
  },
  AUSTRALIA: {
    经度: "133.77514",
    纬度: "-25.27440",
  },
  "SOUTH KOREA": {
    经度: "127.88650",
    纬度: "36.04160",
  },
  TURKEY: {
    经度: "34.99321",
    纬度: "40.15043",
  },
  INDONESIA: {
    经度: "119.86984",
    纬度: "-4.32047",
  },
  "SAUDI ARABIA": {
    经度: "119.86984",
    纬度: "-4.32047",
  },
  ARGENTINA: {
    经度: "-67.51659",
    纬度: "-39.68883",
  },
  EURO: {
    经度: "-67.51659",
    纬度: "-39.68883",
  },
  RUSSIA: {
    经度: "105.31876",
    纬度: "61.52399",
  },
};
